import React, { useState, useEffect } from 'react';
import { signInWithEmailAndPassword, createUserWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { auth, db } from '../firebase';
// @ts-ignore
import bgPattern from '../src/assets/images/clean_optivelo_bg_1780795585568.png';
import { doc, setDoc, getDoc, serverTimestamp, collection, query, where, getCountFromServer, limit } from 'firebase/firestore';
import { LogIn, UserPlus, Mail, Lock, AlertCircle, Check, Waves, Star, Shield, ArrowRight, ShieldCheck, MessageCircle, MailQuestion, Eye, MousePointer2, BrainCircuit, TrendingUp, Sparkles, KeyRound, Loader2, TrendingDown, DollarSign, Cpu, Layers, BarChart3, Zap, Target, Globe, Activity } from 'lucide-react';
import { TermsOfService } from './TermsOfService';
import { PrivacyPolicy } from './PrivacyPolicy';
import { useToast } from './Toast';
import { PublicChat } from './PublicChat';
import { generateAppImage } from '../services/imageService';
import { OptiVeloLogo } from './OptiVeloLogo';
import { markChecklistItemCompleted } from '../src/lib/checklist';
import { useLanguage } from '../src/lib/LanguageContext';
import { LanguageSelector } from './LanguageSelector';


const localTranslations: Record<string, Record<string, string>> = {
  pt: {
    heroTag: "A Nova Era do Marketing Neural",
    heroTitlePart1: "TRANSFORME O SEU TRÁFEGO EM ",
    heroTitleHighlight: "LUCRO REAL",
    heroTitlePart2: " COM A OPTIVELO",
    heroSubtitle: "O OptiVelo é o seu comando central de inteligência. Gere landing pages que vendem 5x mais usando algoritmos de decisão Quantum e escrita persuasiva automatizada.",
    startCreatingBtn: "Começar a Criar Agora",
    whatIsOptiVeloBtn: "O que é o OptiVelo?",
    leadsGenerated: "Leads Gerados",
    iaAccuracy: "Taxa de Acerto IA",
    roiOptimized: "ROI Otimizado",
    activePages: "Páginas Ativas",
    
    knowPlatform: "Conheça a Plataforma",
    whatIsOptiVeloTitle: "O que é o ",
    whatIsOptiVeloDesc: "O OptiVelo é a sua central de comando para transformar ideias em vendas reais na internet. Imagine ter um especialista em marketing, um redator profissional e um analista de dados trabalhando para você 24 horas por dia — é exatamente isso que a nossa plataforma oferece, de forma simples e intuitiva.",
    techValidation: "Tecnologia validada em +2.500 projetos de alta performance.",
    
    card1Title: "Ajustes em Tempo Real",
    card1Desc: "A IA observa o que está funcionando e o que não está. Se ela percebe que uma frase atrai mais atenção, ela prioriza o que traz mais resultado.",
    card2Title: "Escrita Persuasiva",
    card2Desc: "O sistema gera textos focados em resolver as dores do seu cliente e destacar os benefícios do seu produto, aumentando o desejo de compra.",
    card3Title: "Testes Inteligentes",
    card3Desc: "O OptiVelo testa diferentes versões da sua página simultaneamente e escolhe automaticamente a \"vencedora\" que mais vende.",
    card4Title: "Simplicidade Total",
    card4Desc: "Em vez de analisar gráficos complicados, a IA faz o trabalho pesado e te entrega o resultado final: mais vendas com menos esforço.",
    
    quantumDiff: "Diferencial Quantum",
    quantumDiffTitle: "Muito além de Landing Pages: ",
    quantumDiffDesc: "O OptiVelo não apenas cria páginas isoladas. Nossa tecnologia permite que você construa ecossistemas digitais completos, com múltiplos pontos de contato, todos integrados sob a mesma inteligência neural de conversão.",
    multiPages: "Multi-Páginas",
    smartNav: "Navegação Inteligente",
    unlimitedDomains: "Domínios Ilimitados",
    
    scaleEngine: "O Motor da Escala",
    transformBusiness: "Como o OptiVelo Transforma seu Negócio",
    noCoderNeeded: "Você não precisa ser um programador para dominar a arte da conversão. Deixe a IA fazer o trabalho pesado.",
    theProblem: "O Problema: O \"Balde Furado\"",
    theProblemDesc: "A maioria dos empreendedores gasta fortunas em anúncios (Facebook, Instagram, Google), mas suas páginas de vendas são como baldes furados: o tráfego entra, mas a venda não sai.",
    analogyTitle: "A Analogia da Loja Física",
    analogyDesc1: "Imagine uma loja de sapatos: 1.000 pessoas passam na frente, 100 entram, mas apenas 1 compra. Sua taxa é de 1%. Pagar mais anúncios para trazer 2.000 pessoas é caro. ",
    analogyHighlight: "O OptiVelo ajusta sua loja para que 5 pessoas comprem em vez de uma.",
    iaEyeTitle: "O Olho da IA",
    iaEyeDesc: "A IA observa onde as pessoas clicam e onde param de ler, identificando padrões invisíveis ao olho humano.",
    autoTestTitle: "Testes Automáticos",
    autoTestDesc: "O sistema testa cores e botões em tempo real e escolhe automaticamente a versão que mais vende.",
    smartCreationTitle: "Criação Inteligente",
    smartCreationDesc: "Receba sugestões de títulos e layouts baseados em dados de milhões de páginas de alta conversão.",
    
    strategicFormation: "Formação Estratégica",
    heartOfOptiVelo: "O Coração do OptiVelo",
    whoIsTitle: "Quem é o OptiVelo?",
    whoIsDesc: "O OptiVelo é o seu \"diretor de marketing e tecnologia\" movido a IA. Uma plataforma de alta performance que elimina a necessidade de contratar designers, programadores ou copywriters caros para criar suas páginas de vendas.",
    whatWeOfferTitle: "O que oferecemos?",
    offer1: "Criação Instantânea (Smart Copywriter)",
    offer2: "Otimização Inteligente (Optimizer)",
    offer3: "Editor Visual Simplificado",
    offer4: "Métricas em Tempo Real",
    ourObjectiveTitle: "Nosso Objetivo",
    ourObjectiveDesc: "Democratizar a alta conversão. Permitimos que qualquer empreendedor consiga escalar suas vendas com a precisão de dados e a agilidade da IA, focando no que realmente importa: o lucro e o crescimento.",
    philosophyQuote: "\"Unir a agilidade do OptiVelo com a precisão da IA para que o seu negócio alcance o topo sem desperdícios.\"",
    
    uniqueOpp: "Oportunidade Única: Membros Fundadores",
    lockPriceTitle: "Garante o preço antigo por 1 ano inteiro",
    limitReached: "O limite de 100 membros fundadores foi atingido. Os novos preços de mercado já estão em vigor para novas assinaturas.",
    founderText: "A OptiVelo é um ecossistema inovador de alta performance para converter tráfego em lucro real com inteligência neural avançada — um diferencial exclusivo e inédito no mercado. Aproveite o valor promocional de lançamento da plataforma: após completarmos os primeiros 100 membros fundadores, os preços dos planos subirão automaticamente. Garanta sua vaga de pioneiro e trave este valor especial por 12 meses inteiros!",
    slotsRemaining: "Apenas {count} vagas restantes",
    slotsOver: "Vagas de Fundador Esgotadas",
    slotsLimitText: "Limite de 100 membros atingido",
    priceChangeNotice: "Preços novos entram em vigor após 90 dias ou 100 fundadores",
    
    pricingTitle: "Planos que escalam com você",
    pricingSubtitle: "Escolha o plano ideal para a sua operação. Todos os planos incluem nossa IA de conversão.",
    proMonthly: "R$ 197 / mês",
    scaleMonthly: "R$ 297 / mês",
    enterpriseMonthly: "R$ 497 / mês",
    badgeBest: "Mais Popular",
    badgeEnterprise: "Destaque",
    
    testimonialsTitle: "Quem usa o OptiVelo, escala.",
    testimonialsSubtitle: "Histórias de empreendedores que transformaram suas operações com o poder da nossa IA.",
    
    faqTitle: "Dúvidas Frequentes",
    faqSubtitle: "Tudo o que você precisa saber para começar sua jornada Quantum.",
    faq1Q: "O OptiVelo substitui um gestor de tráfego?",
    faq1A: "Não, ele potencializa o trabalho do gestor. O OptiVelo cuida da conversão (o que acontece depois do clique), garantindo que o dinheiro investido em anúncios não seja desperdiçado em páginas ruins.",
    faq2Q: "Preciso saber programar ou desenhar?",
    faq2A: "Absolutamente não. Nossa interface é 100% visual e nossa IA cuida de toda a parte técnica, desde o design até a otimização do código para velocidade máxima.",
    faq3Q: "Posso usar meu próprio domínio?",
    faq3A: "Sim! A partir do plano Scale, você pode conectar seus próprios domínios e subdomínios para manter sua marca profissional.",
    faq4Q: "Como funciona o suporte da IA?",
    faq4A: "Nosso VeloBot v2.0.1 está disponível 24/7 dentro da plataforma para tirar dúvidas técnicas, sugerir melhorias nas suas páginas e ajudar na configuração estratégica.",
    
    footerTagline: "Inteligência que Impulsiona Resultados",
    terms: "Termos de Uso",
    privacy: "Privacidade",
    contact: "Contato",
    rights: "Todos os direitos reservados.",
    engineActive: "Motor OptiVelo Ativo",
    optimized: "Otimizado",
    or: "ou",
    contactUs: "Fale Conosco",
    contactDesc: "Nossa equipe está pronta para ajudar você a escalar seu negócio.",
    contactFailsafe: "Respostas em até 24h úteis",
    backToHome: "Voltar para a Home",
    back: "Voltar",
    recoverPassword: "Recuperar Senha",
    sendResetLink: "Enviaremos um link para seu e-mail",
    emailAddr: "Endereço de E-mail",
    password: "Senha",
    forgotPass: "Esqueceu a senha?",
    weak: "Fraca",
    medium: "Média",
    strong: "Forte",
    processing: "Processando...",
    sendLinkBtn: "Enviar Link",
    loginBtn: "Entrar",
    registerBtn: "Criar Conta",
    backToLogin: "Voltar para o login",
    noAccount: "Não tem uma conta? Cadastre-se",
    hasAccount: "Já tem uma conta? Entre"
  },
  en: {
    heroTag: "The New Era of Neural Marketing",
    heroTitlePart1: "CONVERT YOUR TRAFFIC INTO ",
    heroTitleHighlight: "REAL PROFIT",
    heroTitlePart2: " WITH OPTIVELO",
    heroSubtitle: "OptiVelo is your intelligence command center. Create landing pages that sell 5x more using Quantum decision algorithms and automated persuasive copywriting.",
    startCreatingBtn: "Start Creating Now",
    whatIsOptiVeloBtn: "What is OptiVelo?",
    leadsGenerated: "Leads Generated",
    iaAccuracy: "AI Accuracy Rate",
    roiOptimized: "Optimized ROI",
    activePages: "Active Pages",
    
    knowPlatform: "Explore the Platform",
    whatIsOptiVeloTitle: "What is ",
    whatIsOptiVeloDesc: "OptiVelo is your ultimate command center for transforming concepts into actual revenue online. Imagine a team comprising a dedicated marketing strategist, professional copywriter, and data analyst working for you 24/7 — that is exactly what our platform delivers, simply and elegantly.",
    techValidation: "Validated technology deployed across +2,500 high-performance operations.",
    
    card1Title: "Real-Time Adaptations",
    card1Desc: "The AI monitors user interactions to determine what works and what does not. If it detects a headline capturing superior interest, it automatically prioritizes the winning variant.",
    card2Title: "Persuasive Copywriting",
    card2Desc: "Our built-in engine forms highly targeted copywriting focused on absolute customer resolution, emphasizing product features, elevating purchasing desire.",
    card3Title: "Smart Trials & Tests",
    card3Desc: "OptiVelo executes concurrent variations of your funnels automatically, choosing the highest converting and optimal version without complications.",
    card4Title: "Total Simplicity",
    card4Desc: "Instead of staring at complex analytics charts, our automated neural engines handle the heavy lifting, serving polished customer outcomes.",
    
    quantumDiff: "Quantum Advantage",
    quantumDiffTitle: "Beyond isolated landing pages: ",
    quantumDiffDesc: "OptiVelo goes beyond standard pages. Our framework empowers you to orchestrate complete digital ecosystems with multiple touchpoints fully connected to our conversion core.",
    multiPages: "Multi-Pages",
    smartNav: "Autonomous Navigation",
    unlimitedDomains: "Unlimited Domains",
    
    scaleEngine: "The Scale Engine",
    transformBusiness: "How OptiVelo Empowers Your Growth",
    noCoderNeeded: "No programming or styling workflows necessary. Let our AI do the automated lifting.",
    theProblem: "The Hurdle: The \"Leaking Funnel\"",
    theProblemDesc: "Most marketers waste major capital on paid traffic loops, but standard storefront layout designs act like leaking vessels: traffic enters, but conversions fall off.",
    analogyTitle: "The Storefront Metaphor",
    analogyDesc1: "Consider a traditional retail storefront: 1,000 passersby notice it, 100 step inside, but only 1 checks out. That is a 1% conversion. Paying double for 2,000 prospects is inefficient. ",
    analogyHighlight: "OptiVelo alters your layout so 5 customers checkout instead of one.",
    iaEyeTitle: "The AI Vision",
    iaEyeDesc: "The AI measures exact click maps and reading depth, catching key behavioral trends invisible to the standard eye.",
    autoTestTitle: "Automated Trials",
    autoTestDesc: "The system runs native coloring and button A/B testing dynamically, selecting the supreme conversion layout.",
    smartCreationTitle: "Predictive Layouts",
    smartCreationDesc: "Access proven title ideas and content structure recommendations modeled on high-conversion datasets.",
    
    strategicFormation: "Strategic Architecture",
    heartOfOptiVelo: "The Heart of OptiVelo",
    whoIsTitle: "What is OptiVelo?",
    whoIsDesc: "OptiVelo serves as your AI marketing director and operations lead. A high-efficiency software suite removing the need to outsource expensive creative talent to launch your pages.",
    whatWeOfferTitle: "What is included?",
    offer1: "Instant Generation (Smart Copywriter)",
    offer2: "Intelligent CRO Optimization (Optimizer)",
    offer3: "Visual Interface Layout Editor",
    offer4: "Live Conversion Reporting Metrics",
    ourObjectiveTitle: "Our Objective",
    ourObjectiveDesc: "Democratize high-conversion models. We enable any digital entrepreneur to scale campaigns using pure data precision and agile artificial intelligence, prioritizing cashflow and real growth.",
    philosophyQuote: "\"Blend OptiVelo speed with advanced data models to launch your organization to the top without waste.\"",
    
    uniqueOpp: "Pioneer Offer: Founding Members",
    lockPriceTitle: "Guarantee your pioneer pricing for 12 full months",
    limitReached: "The limit of 100 founding pioneer slots is filled. Standard tiered pricing structures are now active.",
    founderText: "OptiVelo is a premier high-performance ecosystem converting funnel traffic into real profit with advanced neural decision models. Seize our pioneer launch pricing: once the first 100 pioneer slots are filled, standard subscription rates will be locked in. Secure your founding discount now and preserve this rate for 12 months!",
    slotsRemaining: "Only {count} slots remaining",
    slotsOver: "Pioneer slots sold out",
    slotsLimitText: "Limit of 100 pioneer members reached",
    priceChangeNotice: "New tiers establish automatically following 90 days or capacity threshold",
    
    pricingTitle: "Subscription Plans Built to Scale",
    pricingSubtitle: "Unlock the perfect package for your operations. Every single tier includes our conversion-optimized AI tools.",
    proMonthly: "$42 / mo",
    scaleMonthly: "$62 / mo",
    enterpriseMonthly: "$104 / mo",
    badgeBest: "Most Popular",
    badgeEnterprise: "Enterprise Feature",
    
    testimonialsTitle: "They Scale with OptiVelo",
    testimonialsSubtitle: "Read real stories of independent creators and full-service agencies that dramatically increased conversion yields.",
    
    faqTitle: "Frequently Asked Questions",
    faqSubtitle: "Everything you need to know about setting up your Quantum operations.",
    faq1Q: "Does OptiVelo replace my media buyer or ad manager?",
    faq1A: "No, it acts as a force multiplier for them. OptiVelo optimizes customer behavior at the post-click destination, ensuring your advertising dollars are never wasted on flat pages.",
    faq2Q: "Do I need technical engineering or designer skills?",
    faq2A: "Absolutely not. Our visual system is 100% intuitive and the automated AI handles optimization, backend code generation, and mobile page performance.",
    faq3Q: "Can I map my own domain name?",
    faq3A: "Yes, definitely. From the Scale tier and upwards, you can map infinite custom domains and slugs directly to keep absolute professional ownership.",
    faq4Q: "How does the AI assistant support work?",
    faq4A: "Our custom VeloBot v2.0.1 agent assistant is available 24/7 inside the console to resolve system configuration steps and guide optimization strategies.",
    
    footerTagline: "Intelligence Driving Results",
    terms: "Terms of Use",
    privacy: "Privacy Policy",
    contact: "Contact",
    rights: "All rights reserved.",
    engineActive: "OptiVelo Engine Active",
    optimized: "Optimized",
    or: "or",
    contactUs: "Contact Us",
    contactDesc: "Our team is standing by to help you scale your business.",
    contactFailsafe: "Response within 24 business hours",
    backToHome: "Back to Home",
    back: "Back",
    recoverPassword: "Recover Password",
    sendResetLink: "We'll send a password recovery link to your email",
    emailAddr: "Email Address",
    password: "Password",
    forgotPass: "Forgot password?",
    weak: "Weak",
    medium: "Medium",
    strong: "Strong",
    processing: "Processing...",
    sendLinkBtn: "Send Reset Link",
    loginBtn: "Sign In",
    registerBtn: "Sign Up",
    backToLogin: "Back to sign in",
    noAccount: "Don't have an account? Sign up",
    hasAccount: "Already have an account? Sign in"
  },
  es: {
    heroTag: "La Nueva Era del Marketing Neural",
    heroTitlePart1: "TRANSFORME SU TRÁFICO EN ",
    heroTitleHighlight: "GANANCIAS REALES",
    heroTitlePart2: " CON OPTIVELO",
    heroSubtitle: "OptiVelo es su centro de comando de inteligencia de marketing. Genere páginas de destino que vendan 5 veces más utilizando modelos de decisión predictiva y redacción persuasiva automática.",
    startCreatingBtn: "Comenzar a Crear Ahora",
    whatIsOptiVeloBtn: "¿Qué es OptiVelo?",
    leadsGenerated: "Leads Generados",
    iaAccuracy: "Tasa de Acierto IA",
    roiOptimized: "ROI Optimizado",
    activePages: "Páginas Activas",
    
    knowPlatform: "Conozca la Plataforma",
    whatIsOptiVeloTitle: "O que é o ",
    whatIsOptiVeloDesc: "OptiVelo es su estación de comando para transformar conceptos en utilidades concretas en internet. Imagine contar con un estratega de marketing, un redactor profesional y un ingeniero analista de conversión operando 24/7 — eso es precisamente lo que proveemos de manera simple e intuitiva.",
    techValidation: "Tecnología de punta validada en más de 2500 entornos de negocio.",
    
    card1Title: "Ajustes en Tiempo Real",
    card1Desc: "La Inteligencia Artificial estudia lo que funciona y lo que no. Si detecta que cierta frase incentiva mayor retención, la prioriza automáticamente para maximizar resultados.",
    card2Title: "Escrita Persuasiva",
    card2Desc: "Nuestros algoritmos generan copias diseñadas metódicamente para resolver las necesidades profundas del cliente y elevar exponencialmente el deseo de compra.",
    card3Title: "Pruebas Inteligentes",
    card3Desc: "OptiVelo ejecuta pruebas A/B simultáneas con diferentes alternativas de su embudo, seleccionando de forma automatizada la versión más lucrativa.",
    card4Title: "Simplicidade Total",
    card4Desc: "Olvídese de descifrar reportes de métricas tediosas. El sistema procesa la información de comportamiento y le entrega un embudo optimizado para generar ventas.",
    
    quantumDiff: "Diferencial Quantum",
    quantumDiffTitle: "Mucho más que Landing Pages simples: ",
    quantumDiffDesc: "OptiVelo no solo construye páginas individuales. Nuestra plataforma le permite estructurar arquitecturas web multisectoriales, todas unificadas bajo un mismo cerebro de conversión.",
    multiPages: "Multi-Páginas",
    smartNav: "Navegación Inteligente",
    unlimitedDomains: "Domínios Ilimitados",
    
    scaleEngine: "El Motor de Escalabilidad",
    transformBusiness: "Cómo OptiVelo Transforma su Negocio",
    noCoderNeeded: "Sin requerir experiencia previa en programación o ilustración. Deje que la IA arme todo el ecosistema digital.",
    theProblem: "O Problema: O \"Balde Furado\"",
    theProblemDesc: "La mayoría de las marcas invierten sumas considerables en publicidad digital, pero sus páginas destino actúan como recipientes con fugas: reciben tráfico, pero las ventas no se concreta.",
    analogyTitle: "La Metáfora de la Tienda Física",
    analogyDesc1: "Visualice un establecimiento minorista tradicional: 1,000 peatones lo observan, 100 entran, pero solo 1 finaliza su compra. Una tasa de 1%. Comprar más anuncios es inviable. ",
    analogyHighlight: "OptiVelo calibra el ecosistema para que entrenen y compren 5 clientes en lugar de uno.",
    iaEyeTitle: "La Visión de la IA",
    iaEyeDesc: "Nuestros módulos de visión estudian con precisión los puntos refractarios del usuario de forma invisible para la vista humana estándar.",
    autoTestTitle: "Pruebas Automatizadas",
    autoTestDesc: "Pruebe diferentes tonalidades y ubicaciones de botones de forma dinámica, manteniendo permanente la versión de mayor conversión.",
    smartCreationTitle: "Formularios Predictivos",
    smartCreationDesc: "Acceda instantáneamente a patrones estructurales de alta entrega modelados bajo millones de páginas web de primer nivel.",
    
    strategicFormation: "Formación Estratégica",
    heartOfOptiVelo: "El Corazón de OptiVelo",
    whoIsTitle: "¿Quién es OptiVelo?",
    whoIsDesc: "OptiVelo actúa directamente como su director de optimización y copy principal gestionado por IA, suprimiendo la necesidad de contratar perfiles técnicos independientes de alto costo.",
    whatWeOfferTitle: "¿Qué se incluye?",
    offer1: "Generación Inmediata (Smart Copywriter)",
    offer2: "Ajustes Predictivos de Conversión (Optimizer)",
    offer3: "Editor Visual Dinámico Integrado",
    offer4: "Reportes Métricos en Tiempo Real",
    ourObjectiveTitle: "Nuestro Objetivo",
    ourObjectiveDesc: "Democratizar la conversión de alta gama. Equipamos a cualquier emprendedor digital con analíticas precisas de forma automatizada, permitiendo un escalamiento libre de gastos innecesarios.",
    philosophyQuote: "\"Alinee la velocidad de ejecución con la precisión de la analítica predictiva para llevar su negocio a la cima del mercado.\"",
    
    uniqueOpp: "Oportunidad de Lanzamiento: Miembros Fundadores",
    lockPriceTitle: "Congele su suscripción de lanzamiento por 12 meses",
    limitReached: "Límite de 100 pioneros cubierto. Las tarifas estándar de mercado ya están activas.",
    founderText: "OptiVelo es un ecosistema innovador de alto rendimiento para convertir tráfico en ganancias reales con inteligencia neural avanzada. Aproveche la promoción de lanzamiento: una vez cubiertas las primeras 100 vacantes, las tarifas normales se establecerán automáticamente. ¡Asegure su descuento de pionero por 12 meses completos!",
    slotsRemaining: "Solo {count} vacantes disponibles",
    slotsOver: "Vacantes de Fundador Agotadas",
    slotsLimitText: "Límite de 100 pioneros alcanzado",
    priceChangeNotice: "Las nuevas tarifas se imponen luego de 90 días o finalización de cupos promocionales",
    
    pricingTitle: "Planes Flexibles para Escalar",
    pricingSubtitle: "Encuentre el plan ideal para automatizar su negocio. Todos los planes disponen de acceso completo a nuestras utilidades IA.",
    proMonthly: "39 €/ mes",
    scaleMonthly: "59 €/ mes",
    enterpriseMonthly: "99 €/ mes",
    badgeBest: "Más Popular",
    badgeEnterprise: "Opción Corporativa",
    
    testimonialsTitle: "Ellos Escalan con OptiVelo",
    testimonialsSubtitle: "Conozca los testimoniales de agencias y profesionales que expandieron su conversión.",
    
    faqTitle: "Preguntas Frecuentes",
    faqSubtitle: "Respuestas directas para iniciar sus actividades con las plataformas Quantum.",
    faq1Q: "¿OptiVelo reemplaza la labor de un programador o diseñador?",
    faq1A: "No, mas bien potencia drásticamente su rendimiento. OptiVelo se encarga de optimizar la conversión post-clic, impidiendo pérdidas sobre su presupuesto publicitario.",
    faq2Q: "¿Requiero poseer conocimientos avanzados en diseño o código?",
    faq2A: "Absolutamente no. La interfaz es sumamente amigable e interactiva y la IA depura la parte de rendimiento web de modo invisible.",
    faq3Q: "¿Puedo enlazar dominios propios?",
    faq3A: "Sí, por supuesto. A partir de la suscripción Scale, podrá implementar dominios de forma totalmente libre.",
    faq4Q: "¿Cómo funciona la asistencia técnica IA?",
    faq4A: "Contamos con nuestro bot calificado VeloBot v2.0.1 listo 24/7 en el sistema para guiarlo ante cualquier requerimiento operativo.",
    
    footerTagline: "Inteligencia que Impulsa Resultados",
    terms: "Términos de Uso",
    privacy: "Privacidad",
    contact: "Contacto",
    rights: "Todos los derechos reservados.",
    engineActive: "Motor OptiVelo Activo",
    optimized: "Otimizado",
    or: "o",
    contactUs: "Contáctenos",
    contactDesc: "Nuestro equipo está listo para ayudarle a expandir su negocio.",
    contactFailsafe: "Respuestas en menos de 24h hábiles",
    backToHome: "Regresar al Inicio",
    back: "Regresar",
    recoverPassword: "Recuperar Contraseña",
    sendResetLink: "Le enviaremos un enlace de recuperación a su correo",
    emailAddr: "Dirección de Correo",
    password: "Contraseña",
    forgotPass: "¿Olvidó su contraseña?",
    weak: "Débil",
    medium: "Media",
    strong: "Fuerte",
    processing: "Procesando...",
    sendLinkBtn: "Enviar Enlace",
    loginBtn: "Iniciar Sesión",
    registerBtn: "Crear Cuenta",
    backToLogin: "Regresar a iniciar sesión",
    noAccount: "¿No tiene cuenta? Regístrese",
    hasAccount: "¿Ya tiene cuenta? Inicie sesión"
  }
};

export const Auth: React.FC = () => {
  const { showToast } = useToast();
  const { t, language } = useLanguage();
  const [isLogin, setIsLogin] = useState(true);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showAuth, setShowAuth] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showContact, setShowContact] = useState(false);
  const [contactName, setContactName] = useState('');
  const [contactEmail, setContactEmail] = useState('');
  const [contactMessage, setContactMessage] = useState('');
  const [submittingContact, setSubmittingContact] = useState(false);
  const [contactSubmitted, setContactSubmitted] = useState(false);
  const [foundersCount, setFoundersCount] = useState<number>(0);
  const [isPostLaunch, setIsPostLaunch] = useState<boolean>(false);
  const [launchReason, setLaunchReason] = useState<'time' | 'count' | null>(null);

  const handleContactSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!contactName.trim() || !contactEmail.trim() || !contactMessage.trim()) {
      showToast(language === 'en' ? 'Please fill in all fields.' : (language === 'es' ? 'Por favor, complete todos los campos.' : 'Por favor, preencha todos os campos.'), 'error');
      return;
    }
    setSubmittingContact(true);
    try {
      await setDoc(doc(collection(db, 'support_messages')), {
        name: contactName,
        email: contactEmail,
        message: contactMessage,
        createdAt: serverTimestamp(),
        source: 'auth_landing',
        status: 'new'
      });
      setContactSubmitted(true);
      showToast(language === 'en' ? 'Message sent successfully!' : (language === 'es' ? '¡Mensaje enviado con éxito!' : 'Mensagem enviada com sucesso!'), 'success');
      setContactName('');
      setContactEmail('');
      setContactMessage('');
    } catch (err: any) {
      console.error("Error submitting contact form:", err);
      showToast(language === 'en' ? 'Error sending message. Please try again.' : (language === 'es' ? 'Error al enviar mensaje. Intente de nuevo.' : 'Erro ao enviar mensagem. Tente novamente.'), 'error');
    } finally {
      setSubmittingContact(false);
    }
  };

  // Data de Lançamento Oficial
  const LAUNCH_DATE = new Date('2026-04-15');

  const [images, setImages] = useState({
    cockpit: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&q=80&w=1200',
    growth: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=80&w=1200',
    brain: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&q=80&w=1200'
  });

  const loadImages = async () => {
    try {
      const [cockpitImg, growthImg, brainImg] = await Promise.all([
        generateAppImage("Futuristic digital cockpit dashboard with holographic marketing data, neon indigo UI elements, high-tech command center"),
        generateAppImage("Abstract visualization of exponential financial growth, glowing emerald green data streams, rising charts, digital wealth"),
        generateAppImage("Hyper-realistic glowing AI neural network brain, interconnected data nodes, deep indigo and violet light, futuristic intelligence")
      ]);

      setImages({
        cockpit: cockpitImg || 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&q=80&w=1200',
        growth: growthImg || 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=80&w=1200',
        brain: brainImg || 'https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&q=80&w=1200'
      });
    } catch (err: any) {
      console.error("Error loading images:", err);
    }
  };

  useEffect(() => {
    loadImages();

    const fetchFoundersCount = async () => {
      try {
        // Busca da coleção pública de estatísticas para evitar erro de permissão
        const statsDoc = await getDoc(doc(db, 'stats', 'founders'));
        let baseCount = 0;
        
        if (statsDoc.exists()) {
          baseCount = statsDoc.data().count || 0;
        }

        // Adiciona um offset inicial estratégico de 31 membros fundadores (prova social + escassez inicial de 69 vagas)
        const count = baseCount + 31;
        setFoundersCount(count);
        
        const daysSinceLaunch = Math.floor((new Date().getTime() - LAUNCH_DATE.getTime()) / (1000 * 60 * 60 * 24));
        const isTimeExpired = daysSinceLaunch >= 90;
        const isCountReached = count >= 100; 

        if (isCountReached) {
          setIsPostLaunch(true);
          setLaunchReason('count');
        } else if (isTimeExpired) {
          setIsPostLaunch(true);
          setLaunchReason('time');
        } else {
          setIsPostLaunch(false);
          setLaunchReason(null);
        }
      } catch (error) {
        console.error("Erro ao buscar contagem de fundadores:", error);
      }
    };

    fetchFoundersCount();

    // Check for #cadastro hash to open registration automatically
    if (window.location.hash === '#cadastro') {
      setIsLogin(false);
      setShowAuth(true);
    }
  }, []);

  const handleEmailAuth = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (isForgotPassword) {
        try {
          await sendPasswordResetEmail(auth, email);
          showToast('E-mail de recuperação enviado! Verifique sua caixa de entrada.', 'success');
          setIsForgotPassword(false);
        } catch (resetErr: any) {
          if (resetErr.code === 'auth/user-not-found') {
            showToast('Este e-mail ainda não está cadastrado. Clique em "Cadastre-se".', 'error');
          } else {
            throw resetErr;
          }
        }
      } else if (isLogin) {
        await signInWithEmailAndPassword(auth, email, password);
      } else {
        const result = await createUserWithEmailAndPassword(auth, email, password);
        const isAdmin = result.user.email === "geradordeoportunidades@gmail.com";
        const trialEndDate = new Date();
        trialEndDate.setDate(trialEndDate.getDate() + 14);

        await setDoc(doc(db, 'users', result.user.uid), {
          uid: result.user.uid,
          email: result.user.email,
          createdAt: serverTimestamp(),
          role: isAdmin ? 'admin' : 'user',
          subscriptionStatus: isAdmin ? 'pro' : 'trial',
          trialUsed: !isAdmin,
          trialEndDate: isAdmin ? null : trialEndDate,
          subscriptionExpiresAt: isAdmin ? null : trialEndDate,
        });
        showToast('Conta criada com sucesso!', 'success');
        markChecklistItemCompleted('auth');
      }
    } catch (err: any) {
      let msg = 'Ocorreu um erro. Verifique seus dados.';
      if (err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password') {
        msg = 'E-mail ou senha incorretos.';
      } else if (err.code === 'auth/email-already-in-use') {
        msg = 'Este e-mail já está em uso.';
      } else if (err.code === 'auth/invalid-email') {
        msg = 'E-mail inválido.';
      }
      showToast(msg, 'error');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (showTerms) {
    return <TermsOfService onBack={() => setShowTerms(false)} />;
  }

  if (showPrivacy) {
    return <PrivacyPolicy onBack={() => setShowPrivacy(false)} />;
  }

  if (showContact) {
    const activeTrans = localTranslations[language] || localTranslations['pt'];
    
    // Translations for contact form fields
    const formTrans = {
      nameLabel: language === 'en' ? 'Name' : (language === 'es' ? 'Nombre' : 'Nome'),
      emailLabel: language === 'en' ? 'Email' : (language === 'es' ? 'Correo electrónico' : 'E-mail'),
      messageLabel: language === 'en' ? 'Your Message' : (language === 'es' ? 'Su mensaje' : 'Sua Mensagem'),
      messagePlaceholder: language === 'en' ? 'Explain how we can help you...' : (language === 'es' ? 'Explique cómo podemos ayudarle...' : 'Explique como podemos ajudar você...'),
      sendBtn: language === 'en' ? 'Send Message' : (language === 'es' ? 'Enviar mensaje' : 'Enviar Mensagem'),
      sending: language === 'en' ? 'Sending...' : (language === 'es' ? 'Enviando...' : 'Enviando...'),
      successTitle: language === 'en' ? 'Message Sent!' : (language === 'es' ? '¡Mensaje Enviado!' : 'Mensagem Enviada!'),
      successDesc: language === 'en' 
        ? 'Thank you for reaching out. Our high-performance team has been notified and will contact you via email shortly.' 
        : (language === 'es' 
          ? 'Gracias por contactarnos. Nuestro equipo de alto rendimiento ha sido notificado y se pondrá en contacto pronto.' 
          : 'Obrigado por entrar em contato. Nossa equipe de alta performance foi notificada e retornará em breve para o seu e-mail.'),
      newInquiry: language === 'en' ? 'Send another message' : (language === 'es' ? 'Enviar otro mensaje' : 'Enviar outra mensagem')
    };

    return (
      <div className="min-h-screen bg-black flex items-center justify-center p-4">
        <div className="max-w-md w-full premium-card p-8 sm:p-10 text-center space-y-6">
          <div className="w-16 h-16 bg-indigo-500/10 rounded-2xl flex items-center justify-center text-indigo-500 mx-auto">
            <MailQuestion className="w-8 h-8 animate-pulse" />
          </div>
          
          <div className="space-y-2">
            <h2 className="text-2xl font-bold text-white tracking-tight">{activeTrans.contactUs}</h2>
            <p className="text-slate-400 text-xs sm:text-sm">{activeTrans.contactDesc}</p>
          </div>

          {contactSubmitted ? (
            <div className="space-y-6 py-4 animate-float">
              <div className="w-12 h-12 bg-emerald-500/15 rounded-full flex items-center justify-center text-emerald-400 mx-auto">
                <Check className="w-6 h-6" />
              </div>
              <div className="space-y-2">
                <h3 className="text-lg font-bold text-white">{formTrans.successTitle}</h3>
                <p className="text-sm text-slate-400 leading-relaxed max-w-sm mx-auto">{formTrans.successDesc}</p>
              </div>
              <div className="pt-2 flex flex-col gap-2">
                <button 
                  onClick={() => setContactSubmitted(false)}
                  className="w-full py-3 bg-white/5 hover:bg-white/10 border border-white/10 text-xs text-white uppercase tracking-widest font-mono rounded-lg transition-all"
                >
                  {formTrans.newInquiry}
                </button>
                <button 
                  onClick={() => { setShowContact(false); setContactSubmitted(false); }}
                  className="text-xs font-bold text-indigo-400 hover:text-white uppercase tracking-widest pt-2 font-mono"
                >
                  {activeTrans.backToHome}
                </button>
              </div>
            </div>
          ) : (
            <form onSubmit={handleContactSubmit} className="space-y-4 text-left">
              <div className="space-y-1.5">
                <label className="text-xs font-mono uppercase tracking-wider text-slate-400">{formTrans.nameLabel}</label>
                <input 
                  type="text" 
                  value={contactName} 
                  onChange={(e) => setContactName(e.target.value)}
                  placeholder={formTrans.nameLabel}
                  className="w-full px-4 py-3 bg-[#0a0a0a] border border-white/5 focus:border-indigo-500/50 rounded-lg text-sm text-white placeholder-slate-600 outline-none transition-colors"
                  required
                />
              </div>

              <div className="space-y-1.5">
                <label className="text-xs font-mono uppercase tracking-wider text-slate-400">{formTrans.emailLabel}</label>
                <input 
                  type="email" 
                  value={contactEmail} 
                  onChange={(e) => setContactEmail(e.target.value)}
                  placeholder="exemplo@email.com"
                  className="w-full px-4 py-3 bg-[#0a0a0a] border border-white/5 focus:border-indigo-500/50 rounded-lg text-sm text-white placeholder-slate-600 outline-none transition-colors"
                  required
                />
              </div>

              <div className="space-y-1.5">
                <label className="text-xs font-mono uppercase tracking-wider text-slate-400">{formTrans.messageLabel}</label>
                <textarea 
                  rows={4}
                  value={contactMessage} 
                  onChange={(e) => setContactMessage(e.target.value)}
                  placeholder={formTrans.messagePlaceholder}
                  className="w-full px-4 py-3 bg-[#0a0a0a] border border-white/5 focus:border-indigo-500/50 rounded-lg text-sm text-white placeholder-slate-600 outline-none transition-colors resize-none"
                  required
                />
              </div>

              <div className="pt-2">
                <button 
                  type="submit"
                  disabled={submittingContact}
                  className="w-full py-3.5 bg-indigo-500 hover:bg-indigo-400 text-white font-mono font-bold text-xs uppercase tracking-wider rounded-lg transition-colors flex items-center justify-center gap-2"
                >
                  {submittingContact ? (
                    <>
                      <Loader2 className="w-4 h-4 animate-spin" />
                      <span>{formTrans.sending}</span>
                    </>
                  ) : (
                    <span>{formTrans.sendBtn}</span>
                  )}
                </button>
              </div>

              <div className="text-center pt-4 flex flex-col gap-1.5">
                <p className="text-[10px] font-mono text-slate-500 uppercase tracking-widest">{activeTrans.contactFailsafe}</p>
                <button 
                  type="button"
                  onClick={() => setShowContact(false)}
                  className="text-xs font-bold text-indigo-400 hover:text-white uppercase tracking-widest pt-2 font-mono self-center"
                >
                  {activeTrans.backToHome}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    );
  }

  if (showAuth) {
    const activeTrans = localTranslations[language] || localTranslations['pt'];
    return (
      <div className="min-h-screen flex items-center justify-center bg-black p-4">
        <div className="w-full max-w-md p-8 space-y-8 animate-float">
          <button 
            onClick={() => setShowAuth(false)}
            className="text-slate-500 hover:text-white text-[12px] font-bold uppercase tracking-widest flex items-center gap-2"
          >
            <ArrowRight className="w-3 h-3 rotate-180" /> {activeTrans.back}
          </button>
          
          <div className="text-center space-y-4">
            <div 
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-white text-white shadow-xl shadow-teal-500/10 border border-white/20 cursor-pointer hover:scale-105 transition-transform"
            >
              {isForgotPassword ? (
                <KeyRound className="w-8 h-8 text-indigo-500" />
              ) : (
                <OptiVeloLogo size={32} />
              )}
            </div>
            <div className="space-y-1">
              <h1 className="text-4xl font-black tracking-tighter text-white">
                {isForgotPassword ? activeTrans.recoverPassword : 'OptiVelo'}
              </h1>
              <p className="text-[12px] font-bold text-blue-300 uppercase tracking-widest">
                {isForgotPassword ? activeTrans.sendResetLink : activeTrans.footerTagline}
              </p>
            </div>
          </div>

          <div className="premium-card p-8 space-y-6">
            <form onSubmit={handleEmailAuth} className="space-y-5">
              <div className="space-y-2">
                <label className="micro-label">{activeTrans.emailAddr}</label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
                  <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full bg-white/[0.03] border border-white/10 rounded-xl pl-10 pr-4 py-2.5 text-sm text-white focus:border-indigo-500 focus:outline-none transition-all"
                    placeholder="nome@exemplo.com"
                  />
                </div>
              </div>

              {!isForgotPassword && (
                <div className="space-y-2">
                  <div className="flex items-center justify-between">
                    <label className="micro-label">{activeTrans.password}</label>
                    {isLogin && (
                      <button
                        type="button"
                        onClick={() => {
                          setIsForgotPassword(true);
                        }}
                        className="text-[12px] font-bold text-indigo-400 hover:text-indigo-300 transition-colors uppercase tracking-widest"
                      >
                        {activeTrans.forgotPass}
                      </button>
                    )}
                  </div>
                  <div className="relative">
                    <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
                    <input
                      type="password"
                      required={!isForgotPassword}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="w-full bg-white/[0.03] border border-white/10 rounded-xl pl-10 pr-4 py-2.5 text-sm text-white focus:border-indigo-500 focus:outline-none transition-all"
                      placeholder="••••••••"
                    />
                  </div>
                
                {!isLogin && password && (
                  <div className="space-y-2 mt-2 animate-in fade-in slide-in-from-top-1 duration-200">
                    <div className="flex gap-1 h-1">
                      {[1, 2, 3].map((step) => {
                        const strength = (() => {
                          let score = 0;
                          if (password.length >= 8) score++;
                          if (/[A-Z]/.test(password)) score++;
                          if (/[0-9]/.test(password)) score++;
                          if (/[^A-Za-z0-9]/.test(password)) score++;
                          
                          if (score <= 1) return { val: 1, color: 'bg-rose-500', label: activeTrans.weak };
                          if (score === 2) return { val: 2, color: 'bg-amber-500', label: activeTrans.medium };
                          return { val: 3, color: 'bg-emerald-500', label: activeTrans.strong };
                        })();
                        
                        return (
                          <div 
                            key={step}
                            className={`flex-1 rounded-full transition-all duration-500 ${
                              step <= strength.val ? strength.color : 'bg-white/5'
                            }`}
                          />
                        );
                      })}
                    </div>
                    <p className={`text-[12px] font-bold uppercase tracking-widest ${
                      (() => {
                        let score = 0;
                        if (password.length >= 8) score++;
                        if (/[A-Z]/.test(password)) score++;
                        if (/[0-9]/.test(password)) score++;
                        if (/[^A-Za-z0-9]/.test(password)) score++;
                        if (score <= 1) return 'text-rose-500';
                        if (score === 2) return 'text-amber-500';
                        return 'text-emerald-500';
                      })()
                    }`}>
                      {activeTrans.password} {
                        (() => {
                          let score = 0;
                          if (password.length >= 8) score++;
                          if (/[A-Z]/.test(password)) score++;
                          if (/[0-9]/.test(password)) score++;
                          if (/[^A-Za-z0-9]/.test(password)) score++;
                          if (score <= 1) return activeTrans.weak;
                          if (score === 2) return activeTrans.medium;
                          return activeTrans.strong;
                        })()
                      }
                    </p>
                  </div>
                )}
              </div>
              )}

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-indigo-500 text-white py-3 rounded-xl text-sm font-bold hover:bg-indigo-400 transition-all shadow-lg shadow-indigo-500/20 disabled:opacity-50"
              >
                {loading ? activeTrans.processing : (isForgotPassword ? activeTrans.sendLinkBtn : isLogin ? activeTrans.loginBtn : activeTrans.registerBtn)}
              </button>
            </form>
          </div>

          <div className="text-center">
            {isForgotPassword ? (
              <button
                onClick={() => {
                  setIsForgotPassword(false);
                }}
                className="text-xs font-medium text-slate-500 hover:text-indigo-400 transition-colors"
               >
                {activeTrans.backToLogin}
              </button>
            ) : (
              <button
                onClick={() => {
                  setIsLogin(!isLogin);
                }}
                className="text-xs font-medium text-slate-500 hover:text-indigo-400 transition-colors"
              >
                {isLogin ? activeTrans.noAccount : activeTrans.hasAccount}
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  const activeTrans = localTranslations[language] || localTranslations['pt'];

  return (
    <div className="min-h-screen bg-black text-white selection:bg-indigo-500/30 overflow-x-hidden relative">
      {/* Cinematic High-Performance Server & Network Background - Covers entire page continuously */}
      <div className="fixed inset-0 w-full h-full pointer-events-none overflow-hidden select-none z-0">
        <img 
          src={bgPattern || "/src/assets/images/clean_optivelo_bg_1780795585568.png"} 
          alt="OptiVelo Core Infrastructure Background" 
          className="w-full h-full object-cover opacity-25 saturate-100 brightness-90 transition-all duration-700" 
          referrerPolicy="no-referrer"
        />
        {/* Soft, ultra-professional gradients to ensure white website texts remain extremely crisp and easy to read */}
        <div className="absolute inset-0 bg-gradient-to-b from-black via-black/85 to-black" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_30%,#000000_90%)]" />
      </div>

      {/* Navbar */}
      <nav className="fixed top-0 w-full z-50 bg-black/50 backdrop-blur-xl border-b border-white/5 px-4 lg:px-8 py-4 flex justify-between items-center">
        <div 
          onClick={() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
          }}
          className="flex items-center"
        >
          <OptiVeloLogo variant="full" size={32} className="hover:scale-105 transition-transform cursor-pointer" />
        </div>
        <div className="flex items-center gap-3 lg:gap-6">
          <LanguageSelector variant="header" />
          <button onClick={() => setShowAuth(true)} className="text-xs lg:text-sm font-bold text-slate-400 hover:text-white transition-colors">
            {language === 'en' ? 'Sign In' : (language === 'es' ? 'Iniciar Sesión' : 'Entrar')}
          </button>
          <button onClick={() => { setIsLogin(false); setShowAuth(true); }} className="px-3 py-1.5 lg:px-5 lg:py-2 bg-indigo-500 text-white text-xs lg:text-sm font-bold rounded-xl shadow-lg shadow-indigo-500/20 hover:bg-indigo-400 transition-all">
            {language === 'en' ? 'Get Started' : (language === 'es' ? 'Empezar Agora' : 'Começar Agora')}
          </button>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="pt-40 lg:pt-52 pb-24 px-4 lg:px-8 text-center relative overflow-hidden bg-transparent border-b border-white/5 z-10">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full lg:w-[1200px] h-[600px] bg-indigo-500/5 blur-[150px] rounded-full pointer-events-none z-0" />
        
        {/* High legibility container wrapper */}
        <div className="relative z-10 space-y-12 w-full max-w-7xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-indigo-500/10 border border-indigo-500/20 rounded-full text-indigo-400 text-xs font-bold uppercase tracking-widest animate-float">
            <Sparkles className="w-4 h-4 fill-indigo-400" />
            {activeTrans.heroTag}
          </div>
          
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-sans font-black tracking-tight max-w-5xl mx-auto leading-[1.1] notranslate uppercase animate-in" translate="no">
            {activeTrans.heroTitlePart1}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 via-white to-emerald-400">
              {activeTrans.heroTitleHighlight}
            </span>
            {activeTrans.heroTitlePart2}
          </h1>

          <p className="text-slate-400 text-sm sm:text-base md:text-lg max-w-3xl mx-auto px-4 leading-relaxed font-medium">
            {activeTrans.heroSubtitle}
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 pt-6 px-4">
            <button 
              onClick={() => { setIsLogin(false); setShowAuth(true); }} 
              className="w-full sm:w-auto px-10 py-5 bg-indigo-500 text-white font-bold rounded-xl hover:bg-indigo-455 transition-all flex items-center justify-center gap-3 text-sm tracking-widest uppercase shadow-xl shadow-indigo-500/25 relative overflow-hidden group"
            >
              <span className="relative z-10 flex items-center gap-3">
                {language === 'en' ? 'Get Started' : (language === 'es' ? 'Comenzar Agora' : 'Começar Agora')} <ArrowRight className="w-4 h-4" />
              </span>
            </button>
            <button 
              onClick={() => document.getElementById('what-is-optivelo')?.scrollIntoView({ behavior: 'smooth' })}
              className="w-full sm:w-auto px-10 py-5 bg-transparent border border-white/10 text-white font-bold rounded-xl hover:bg-white/5 transition-all text-sm tracking-widest uppercase"
            >
              {language === 'en' ? 'Explore ecosystem' : (language === 'es' ? 'Explorar ecosistema' : 'Explorar ecossistema')}
            </button>
          </div>

          {/* Stats Ticker */}
          <div className="pt-20 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-5xl mx-auto border-t border-white/5">
            <div className="space-y-2">
              <p className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">2.8M+</p>
              <p className="text-xs sm:text-sm font-bold text-slate-500 uppercase tracking-widest">{activeTrans.leadsGenerated}</p>
            </div>
            <div className="space-y-2">
              <p className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">98.4%</p>
              <p className="text-xs sm:text-sm font-bold text-slate-500 uppercase tracking-widest">{activeTrans.iaAccuracy}</p>
            </div>
            <div className="space-y-2">
              <p className="text-3xl sm:text-4xl font-extrabold text-emerald-400 tracking-tight">+312%</p>
              <p className="text-xs sm:text-sm font-bold text-slate-500 uppercase tracking-widest">{activeTrans.roiOptimized}</p>
            </div>
            <div className="space-y-2">
              <p className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">12K+</p>
              <p className="text-xs sm:text-sm font-bold text-slate-500 uppercase tracking-widest">{activeTrans.activePages}</p>
            </div>
          </div>
        </div>
      </section>

      {/* What is OptiVelo */}
      <section id="what-is-optivelo" className="py-20 lg:py-32 px-4 lg:px-8 bg-[#030303] border-b border-white/5 relative overflow-hidden z-10">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full lg:w-[1000px] h-[400px] bg-indigo-500/5 blur-[120px] rounded-full pointer-events-none" />
        <div className="max-w-7xl mx-auto space-y-16 relative z-10">
          <div className="text-center space-y-4 max-w-3xl mx-auto">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/5 border border-white/10 rounded-full text-slate-400 text-[12px] font-mono tracking-wider uppercase">
              {activeTrans.knowPlatform}
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-sans font-black tracking-tight leading-[1.1]">
              {activeTrans.whatIsOptiVeloTitle}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-indigo-300">OptiVelo</span>?
            </h2>
            <p className="text-slate-400 text-sm sm:text-base leading-relaxed">
              {activeTrans.whatIsOptiVeloDesc}
            </p>
            <div className="pt-2 text-xs font-bold text-slate-500 uppercase tracking-wider">
              {activeTrans.techValidation}
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="premium-card p-8 space-y-4 hover:border-indigo-500/30 transition-all group">
              <div className="w-12 h-12 bg-indigo-500/10 rounded-2xl flex items-center justify-center text-indigo-400 group-hover:scale-110 transition-transform">
                <Activity className="w-6 h-6" />
              </div>
              <h3 className="text-lg font-bold text-white tracking-tight">{activeTrans.card1Title}</h3>
              <p className="text-sm text-slate-400 leading-relaxed">{activeTrans.card1Desc}</p>
            </div>

            <div className="premium-card p-8 space-y-4 hover:border-indigo-500/30 transition-all group">
              <div className="w-12 h-12 bg-indigo-500/10 rounded-2xl flex items-center justify-center text-indigo-400 group-hover:scale-110 transition-transform">
                <BrainCircuit className="w-6 h-6" />
              </div>
              <h3 className="text-lg font-bold text-white tracking-tight">{activeTrans.card2Title}</h3>
              <p className="text-sm text-slate-400 leading-relaxed">{activeTrans.card2Desc}</p>
            </div>

            <div className="premium-card p-8 space-y-4 hover:border-indigo-500/30 transition-all group">
              <div className="w-12 h-12 bg-indigo-500/10 rounded-2xl flex items-center justify-center text-indigo-400 group-hover:scale-110 transition-transform">
                <Cpu className="w-6 h-6" />
              </div>
              <h3 className="text-lg font-bold text-white tracking-tight">{activeTrans.card3Title}</h3>
              <p className="text-sm text-slate-400 leading-relaxed">{activeTrans.card3Desc}</p>
            </div>

            <div className="premium-card p-8 space-y-4 hover:border-indigo-500/30 transition-all group">
              <div className="w-12 h-12 bg-indigo-500/10 rounded-2xl flex items-center justify-center text-indigo-400 group-hover:scale-110 transition-transform">
                <BarChart3 className="w-6 h-6" />
              </div>
              <h3 className="text-lg font-bold text-white tracking-tight">{activeTrans.card4Title}</h3>
              <p className="text-sm text-slate-400 leading-relaxed">{activeTrans.card4Desc}</p>
            </div>
          </div>
        </div>
      </section>

      {/* How it Works Section */}
      <section id="how-it-works" className="py-20 lg:py-32 px-4 lg:px-8 bg-[#000000] border-b border-white/5 relative overflow-hidden z-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-indigo-500/5 blur-[120px] rounded-full pointer-events-none" />
        <div className="max-w-7xl mx-auto space-y-16 relative z-10">
          <div className="text-center space-y-4 max-w-3xl mx-auto">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-500/15 border border-emerald-500/20 rounded-full text-emerald-400 text-[12px] font-bold uppercase tracking-widest animate-pulse">
              <Zap className="w-4 h-4 fill-emerald-400" />
              {activeTrans.scaleEngine}
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-sans font-black tracking-tight leading-[1.1]">
              {activeTrans.transformBusiness}
            </h2>
            <p className="text-slate-400 text-sm sm:text-base leading-relaxed">
              {activeTrans.noCoderNeeded}
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-stretch">
            {/* The Problem */}
            <div className="premium-card p-8 lg:p-12 space-y-6 flex flex-col justify-between border-rose-500/10 hover:border-rose-500/20 transition-all text-left">
              <div className="space-y-6">
                <div className="w-12 h-12 bg-rose-500/10 rounded-2xl flex items-center justify-center text-rose-400">
                  <TrendingDown className="w-6 h-6" />
                </div>
                <div className="space-y-2">
                  <h3 className="text-xl font-bold text-white tracking-tight">{activeTrans.theProblem}</h3>
                  <p className="text-sm text-slate-400 leading-relaxed">
                    {activeTrans.theProblemDesc}
                  </p>
                </div>
                <div className="p-6 bg-rose-500/5 border border-rose-500/10 rounded-2xl space-y-3">
                  <h4 className="text-sm font-bold text-rose-400 uppercase tracking-widest flex items-center gap-2">
                    <AlertCircle className="w-4 h-4" /> {activeTrans.analogyTitle}
                  </h4>
                  <p className="text-xs text-rose-300 leading-relaxed">
                    {activeTrans.analogyDesc1}
                  </p>
                </div>
              </div>
              <div className="pt-4 border-t border-white/5 text-slate-500 text-xs font-medium">
                {language === 'en' ? 'Incurring huge losses in paid advertising budget.' : 'Desperdício massivo de investimento em tráfego pago.'}
              </div>
            </div>

            {/* The Solution */}
            <div className="premium-card p-8 lg:p-12 space-y-6 flex flex-col justify-between border-emerald-500/10 hover:border-emerald-500/20 transition-all bg-gradient-to-br from-black to-indigo-950/20 text-left">
              <div className="space-y-6">
                <div className="w-12 h-12 bg-emerald-500/10 rounded-2xl flex items-center justify-center text-emerald-400">
                  <TrendingUp className="w-6 h-6 animate-pulse" />
                </div>
                <div className="space-y-2">
                  <h3 className="text-xl font-bold text-white tracking-tight">O OptiVelo: A Solução de Alta Conversão</h3>
                  <p className="text-sm text-slate-400 leading-relaxed">
                    O OptiVelo redefine essa realidade. Em vez de simplesmente derramar mais tráfego, nós consertamos o layout, otimizamos o tempo de carregamento e inserimos copywriting neural de alta conversão.
                  </p>
                </div>
                <div className="p-6 bg-emerald-500/5 border border-emerald-500/10 rounded-2xl space-y-3">
                  <h4 className="text-sm font-bold text-emerald-400 uppercase tracking-widest flex items-center gap-2">
                    <Check className="w-4 h-3 text-emerald-400" /> O Efeito Multiplicador
                  </h4>
                  <p className="text-xs text-emerald-300 font-bold leading-relaxed">
                    {activeTrans.analogyHighlight}
                  </p>
                </div>
              </div>
              <div className="pt-4 border-t border-white/5 text-indigo-400 text-xs font-bold uppercase tracking-widest flex items-center gap-2">
                <Sparkles className="w-4 h-4 animate-spin text-indigo-400" /> {language === 'en' ? 'Maximized return on ad spend.' : 'Retorno sobre Investimento Amplificado.'}
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8 pt-8 text-left">
            <div className="premium-card p-8 space-y-4 hover:border-indigo-500/30 transition-all group">
              <div className="w-10 h-10 bg-indigo-500/10 rounded-xl flex items-center justify-center text-indigo-400">
                <Eye className="w-5 h-5" />
              </div>
              <h4 className="text-base font-bold text-white tracking-tight">{activeTrans.iaEyeTitle}</h4>
              <p className="text-xs text-slate-400 leading-relaxed">{activeTrans.iaEyeDesc}</p>
            </div>

            <div className="premium-card p-8 space-y-4 hover:border-indigo-500/30 transition-all group">
              <div className="w-10 h-10 bg-indigo-500/10 rounded-xl flex items-center justify-center text-indigo-400">
                <Cpu className="w-5 h-5" />
              </div>
              <h4 className="text-base font-bold text-white tracking-tight">{activeTrans.autoTestTitle}</h4>
              <p className="text-xs text-slate-400 leading-relaxed">{activeTrans.autoTestDesc}</p>
            </div>

            <div className="premium-card p-8 space-y-4 hover:border-indigo-500/30 transition-all group">
              <div className="w-10 h-10 bg-indigo-500/10 rounded-xl flex items-center justify-center text-indigo-400">
                <Sparkles className="w-5 h-5" />
              </div>
              <h4 className="text-base font-bold text-white tracking-tight">{activeTrans.smartCreationTitle}</h4>
              <p className="text-xs text-slate-400 leading-relaxed">{activeTrans.smartCreationDesc}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Strategic Formation / About Us */}
      <section id="about-us" className="py-20 lg:py-32 px-4 lg:px-8 bg-[#030303] border-b border-white/5 relative overflow-hidden z-10">
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-indigo-500/5 blur-[120px] rounded-full pointer-events-none" />
        <div className="max-w-7xl mx-auto space-y-16 relative z-10 text-left">
          <div className="text-center space-y-4 max-w-3xl mx-auto mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-indigo-500/10 border border-indigo-500/20 rounded-full text-indigo-400 text-[12px] font-bold uppercase tracking-widest leading-none">
              <ShieldCheck className="w-4 h-4" />
              {activeTrans.strategicFormation}
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-sans font-black tracking-tight text-white uppercase text-center">
              {activeTrans.heartOfOptiVelo}
            </h2>
          </div>

          <div className="grid lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-7 space-y-8">
              <div className="space-y-4">
                <h3 className="text-2xl font-black text-white tracking-tight">{activeTrans.whoIsTitle}</h3>
                <p className="text-slate-400 text-sm leading-relaxed font-normal">
                  {activeTrans.whoIsDesc}
                </p>
              </div>

              <div className="space-y-4">
                <h4 className="text-lg font-bold text-white tracking-tight">{activeTrans.whatWeOfferTitle}</h4>
                <div className="grid sm:grid-cols-2 gap-4">
                  <div className="flex items-center gap-3 p-4 bg-white/[0.02] border border-white/5 rounded-xl">
                    <div className="w-2 h-2 rounded-full bg-indigo-500"></div>
                    <span className="text-xs text-slate-400 font-bold">{activeTrans.offer1}</span>
                  </div>
                  <div className="flex items-center gap-3 p-4 bg-white/[0.02] border border-white/5 rounded-xl">
                    <div className="w-2 h-2 rounded-full bg-emerald-500"></div>
                    <span className="text-xs text-slate-400 font-bold">{activeTrans.offer2}</span>
                  </div>
                  <div className="flex items-center gap-3 p-4 bg-white/[0.02] border border-white/5 rounded-xl">
                    <div className="w-2 h-2 rounded-full bg-indigo-500"></div>
                    <span className="text-xs text-slate-400 font-bold">{activeTrans.offer3}</span>
                  </div>
                  <div className="flex items-center gap-3 p-4 bg-white/[0.02] border border-white/5 rounded-xl">
                    <div className="w-2 h-2 rounded-full bg-indigo-500"></div>
                    <span className="text-xs text-slate-400 font-bold">{activeTrans.offer4}</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="lg:col-span-5 premium-card p-8 lg:p-10 space-y-6 border-indigo-500/10">
              <div className="space-y-2">
                <h3 className="text-lg font-bold text-white tracking-tight">{activeTrans.ourObjectiveTitle}</h3>
                <p className="text-xs text-slate-400 leading-relaxed font-normal">
                  {activeTrans.ourObjectiveDesc}
                </p>
              </div>
              <div className="pt-6 border-t border-white/5">
                <p className="text-xs text-indigo-400 leading-relaxed font-mono italic">
                  {activeTrans.philosophyQuote}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Founders Promotion Banner */}
      <section className="py-12 px-4 lg:px-8 max-w-7xl mx-auto relative z-10">
        <div className="bg-[#0a0a0a] border border-white/5 rounded-[1.5rem] p-8 lg:p-12 text-left space-y-6 relative overflow-hidden group transition-all duration-700">
          <div className="absolute top-0 right-0 w-96 h-96 bg-indigo-500/5 blur-[120px] rounded-full pointer-events-none" />
          <div className="relative z-10 space-y-4 max-w-3xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-white/5 border border-white/15 rounded-full text-indigo-400 font-mono text-[10px] uppercase tracking-[0.2em]">
              <Star className="w-3.5 h-3.5 fill-indigo-400" />
              {activeTrans.uniqueOpp}
            </div>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-sans font-black text-white tracking-tight uppercase">
              {isPostLaunch ? (language === 'en' ? 'Launch Offer Concluded' : (language === 'es' ? 'Oferta de Lanzamiento Finalizada' : 'Oferta de Lançamento Encerrada')) : activeTrans.lockPriceTitle}
            </h2>
            <p className="text-slate-400 text-sm lg:text-base font-normal leading-relaxed">
              {isPostLaunch ? activeTrans.limitReached : activeTrans.founderText}
            </p>
            <div className="pt-4 flex flex-col sm:flex-row items-start sm:items-center gap-6">
              <div className="flex items-center gap-2">
                <div className={`w-2 h-2 ${isPostLaunch ? 'bg-rose-400' : 'bg-emerald-400'} rounded-full animate-pulse`}></div>
                <span className="text-xs font-mono font-bold text-slate-300 uppercase tracking-widest">
                  {isPostLaunch ? activeTrans.slotsOver : activeTrans.slotsRemaining.replace('{count}', String(100 - foundersCount))}
                </span>
              </div>
              <div className="h-px w-8 bg-white/10 hidden sm:block"></div>
              <p className="text-[10px] tracking-wider uppercase text-slate-500 font-mono">
                {isPostLaunch ? (language === 'en' ? 'Post-Launch Pricing Active' : (language === 'es' ? 'Precios de Post-Lanzamiento Activos' : 'Preços de Pós-Lançamento em Vigor')) : activeTrans.priceChangeNotice}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Comparison Section */}
      <section className="py-24 px-4 lg:px-8 max-w-5xl mx-auto border-t border-white/5 relative z-10">
        <div className="space-y-16">
          <div className="text-left space-y-4 max-w-3xl">
            <div className="flex items-center gap-2 text-indigo-400 font-mono text-xs uppercase tracking-[0.25em]">
              <div className="w-1.5 h-1.5 rounded-full bg-indigo-400" />
              <span>03 / COST EFFICIENCY</span>
            </div>
            <h2 className="text-3xl lg:text-4xl font-sans font-black text-white tracking-tight uppercase">
              {language === 'en' ? 'Why OptiVelo is the Smart Choice' : (language === 'es' ? '¿Por qué OptiVelo es la elección inteligente?' : 'Por que o OptiVelo é a escolha inteligente?')}
            </h2>
            <p className="text-slate-400 text-sm font-normal">
              {language === 'en' ? 'Compare the cost of raw external systems against our integrated suite.' : (language === 'es' ? 'Compare el costo de las herramientas globales con nuestra solución nativa.' : 'Compare o custo de ferramentas globais com a nossa solução nativa.')}
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 border-t border-b border-white/5 divide-y md:divide-y-0 md:divide-x divide-white/5">
            {/* Global Tools */}
            <div className="py-12 md:pr-8 lg:pr-10 space-y-6 text-left">
              <div className="flex items-center gap-3 text-slate-500 font-mono">
                <span className="text-xs uppercase tracking-widest">
                  {language === 'en' ? 'Global Tool Suites' : (language === 'es' ? 'Herramientas Globales' : 'Ferramentas Globais')}
                </span>
              </div>
              <div className="space-y-1">
                <div className="flex items-baseline gap-1 opacity-50">
                  <span className="text-sm font-bold">{language === 'en' ? '$' : (language === 'es' ? '€' : 'R$')}</span>
                  <span className="text-4xl font-sans font-bold tracking-tighter text-white">
                    {language === 'en' ? '99' : (language === 'es' ? '99' : '550')}+
                  </span>
                  <span className="text-xs font-mono tracking-wider">
                    {language === 'en' ? '/ mo' : (language === 'es' ? '/ mes' : '/ mês')}
                  </span>
                </div>
                <p className="text-[11px] text-slate-500 font-normal italic">
                  {language === 'en' ? 'Based on premium standard software subscriptions' : (language === 'es' ? 'Basado en licencias corporativas básicas' : 'Baseado em planos de $99 USD + IOF')}
                </p>
              </div>
              <ul className="space-y-3">
                <li className="flex items-center gap-2 text-xs text-slate-500 flex-row">
                  <div className="w-1.5 h-1.5 bg-slate-700 rounded-full" />
                  {language === 'en' ? 'Slow email-only english support' : (language === 'es' ? 'Soporte limitado, principalmente en inglés' : 'Suporte apenas em inglês')}
                </li>
                <li className="flex items-center gap-2 text-xs text-slate-500 flex-row">
                  <div className="w-1.5 h-1.5 bg-slate-700 rounded-full" />
                  {language === 'en' ? 'Steep learning curve & configuration sprawl' : (language === 'es' ? 'Complejidad en instalación y ajustes de DNS' : 'Complexidade de configuração')}
                </li>
                <li className="flex items-center gap-2 text-xs text-slate-500 flex-row">
                  <div className="w-1.5 h-1.5 bg-slate-700 rounded-full" />
                  {language === 'en' ? 'AI add-ons billed extra' : (language === 'es' ? 'Suscripción de Inteligencia Artificial separada' : 'IA cobrada à parte')}
                </li>
              </ul>
            </div>

            {/* OptiVelo */}
            <div className="py-12 md:pl-8 lg:pl-10 space-y-6 text-left relative overflow-hidden">
              <div className="flex items-center gap-3 text-indigo-400 font-mono">
                <span className="text-xs uppercase tracking-widest">OptiVelo Suite</span>
              </div>
              <div className="space-y-1">
                <div className="flex items-baseline gap-1 text-white">
                  <span className="text-sm font-bold">{language === 'en' ? '$' : (language === 'es' ? '€' : 'R$')}</span>
                  <span className="text-4xl font-sans font-bold tracking-tighter">
                    {language === 'en' ? (isPostLaunch ? '62.00' : '42.00') : (language === 'es' ? (isPostLaunch ? '59.00' : '39.00') : (isPostLaunch ? '297' : '197'))}
                  </span>
                  <span className="text-xs font-mono tracking-wider">
                    {language === 'en' ? '/ mo' : (language === 'es' ? '/ mes' : '/ mês')}
                  </span>
                </div>
                <p className="text-[11px] text-indigo-400 font-normal">
                  {language === 'en' ? `Flat ${isPostLaunch ? 'Elite' : 'Founding'} rate, no surprise conversion fees` : (language === 'es' ? `Tarifa de ${isPostLaunch ? 'Miembro Elite' : 'Miembro Fundador'} fija, sin sorpresas fiscales` : `Preço ${isPostLaunch ? 'Elite' : 'Fundador'} em Real, sem surpresas`)}
                </p>
              </div>
              <ul className="space-y-3">
                <li className="flex items-center gap-2 text-xs text-indigo-200">
                  <Check className="w-3.5 h-3.5 text-indigo-400" />
                  {language === 'en' ? 'Instant priority multi-language support' : (language === 'es' ? 'Soporte prioritario localizado y fluido' : 'Suporte prioritário em Português')}
                </li>
                <li className="flex items-center gap-2 text-xs text-indigo-200">
                  <Check className="w-3.5 h-3.5 text-indigo-400" />
                  {language === 'en' ? 'Quantum AI suite natively fully-included' : (language === 'es' ? 'IA Quantum integrada directamente en su ecosistema' : 'IA Quantum inclusa no plano')}
                </li>
                <li className="flex items-center gap-2 text-xs text-indigo-200">
                  <Check className="w-3.5 h-3.5 text-indigo-400" />
                  {language === 'en' ? 'Comprehensive active conversion optimization (CRO)' : (language === 'es' ? 'Enfoque absoluto y riguroso en conversiones' : 'Foco total em conversão (CRO)')}
                </li>
              </ul>
            </div>
          </div>

          <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 text-left border-b border-white/5 pb-10">
            <div className="flex items-center gap-4">
              <div className="text-left space-y-1">
                <p className="text-[10px] font-mono text-slate-500 uppercase tracking-widest">
                  {language === 'en' ? 'Estimated Annual Savings' : (language === 'es' ? 'Ahorro Anual Estimado' : 'Economia Estimada')}
                </p>
                <p className="text-2xl font-bold text-white tracking-tight font-sans">
                  {language === 'en' ? '$684.00' : (language === 'es' ? '720,00 €' : 'R$ 3.636,00')}{' '}
                  <span className="text-slate-500 text-xs font-mono tracking-wider uppercase">
                    {language === 'en' ? '/ year' : (language === 'es' ? '/ año' : '/ ano')}
                  </span>
                </p>
              </div>
            </div>
            <p className="text-xs text-slate-500 max-w-md leading-relaxed font-normal">
              {language === 'en' 
                ? 'Beyond direct software cost cuts, our active users register a 30% reduction in advertising conversion drops due to our automated neural algorithms.' 
                : (language === 'es' 
                  ? 'Además del ahorro inmediato, nuestros usuarios experimentan un incremento promedio del 30% en conversiones gracias a los modelos predictivos de la IA.' 
                  : 'Além da economia direta na assinatura, nossos usuários reportam uma redução média de **30% no desperdício de tráfego pago** graças às otimizações da nossa IA.')}
            </p>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-24 px-4 lg:px-8 max-w-7xl mx-auto space-y-16 border-t border-white/5 relative z-10">
        <div className="text-left space-y-4 max-w-3xl">
          <div className="flex items-center gap-2 text-indigo-400 font-mono text-xs uppercase tracking-[0.25em]">
            <div className="w-1.5 h-1.5 rounded-full bg-indigo-400" />
            <span>04 / SUBSCRIPTIONS</span>
          </div>
          <h2 className="text-3xl lg:text-4xl font-sans font-black text-white tracking-tight uppercase">
            {language === 'en' ? 'Plans Built to Scale with You' : (language === 'es' ? 'Planes diseñados para escalar' : 'Planos que escalam com você')}
          </h2>
          <p className="text-sm text-slate-400 font-normal">
            {language === 'en' ? 'Choose the ideal option for your business phase.' : (language === 'es' ? 'Seleccione la mejor alternativa para su momento comercial.' : 'Escolha a melhor opção para o seu momento atual.')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          <LandingPricingCard 
            title={language === 'en' ? '14-Day Free Trial' : (language === 'es' ? '14 Días Gratis' : '14 Dias Grátis')}
            price="0"
            desc={language === 'en' ? 'Experience the full power of OptiVelo with no commitment for 14 days.' : (language === 'es' ? 'Pruebe el poder total de OptiVelo sin compromiso por 14 días.' : 'Experimente o poder total do OptiVelo sem compromisso por 14 dias.')}
            features={[
              { 
                text: language === 'en' ? 'Full Access (Pro)' : (language === 'es' ? 'Acceso Total (Pro)' : 'Acesso Total (Plano Pro)'), 
                desc: language === 'en' ? 'Test all the advanced features of our AI.' : (language === 'es' ? 'Pruebe todas las capacidades avanzadas de nuestra IA.' : 'Teste todas as funcionalidades avançadas da nossa IA.') 
              },
              { 
                text: language === 'en' ? 'Up to 5 AI Generations' : (language === 'es' ? 'Hasta 5 Generaciones con IA' : 'Até 5 Gerações de IA'), 
                desc: language === 'en' ? 'Test complete page creations and copy layouts during trial.' : (language === 'es' ? 'Pruebe la creación de páginas completas y copys en su prueba.' : 'Teste criações de páginas completas e copys durante seu teste.') 
              },
              { 
                text: language === 'en' ? 'Unlimited Landing Pages' : (language === 'es' ? 'Páginas Ilimitadas' : 'Landing Pages Ilimitadas'), 
                desc: language === 'en' ? 'Create and publish as many pages as you want.' : (language === 'es' ? 'Cree y publique tantas páginas como desee.' : 'Crie e publique quantas páginas desejar no teste.') 
              },
              { 
                text: language === 'en' ? 'Active Decision AI' : (language === 'es' ? 'IA de Decisión Activa' : 'IA de Decisão Ativa'), 
                desc: language === 'en' ? 'Let our AI optimize your conversions in real time.' : (language === 'es' ? 'Deje que la IA optimice conversiones en tiempo real.' : 'Deixe nossa IA otimizar suas conversões em tempo real.') 
              },
              { 
                text: language === 'en' ? 'No Credit Card Needed' : (language === 'es' ? 'Sin Tarjeta de Crédito' : 'Sem Cartão de Crédito'), 
                desc: language === 'en' ? 'Get started right now without entering billing details.' : (language === 'es' ? 'Comience de inmediato sin ingresar datos de pago.' : 'Comece agora mesmo sem precisar inserir dados de pagamento.') 
              }
            ]}
            onAction={() => { setIsLogin(false); setShowAuth(true); }}
          />

          <LandingPricingCard 
            title="Pro"
            price={isPostLaunch ? "297" : "197"}
            anchorPrice="297"
            isPostLaunch={isPostLaunch}
            desc={language === 'en' ? 'The best value-for-money for professionals and growing businesses.' : (language === 'es' ? 'La mejor relación calidad-precio para profesionales y marcas.' : 'O melhor custo-benefício para profissionais e negócios em crescimento.')}
            highlighted
            badge={language === 'en' ? 'Most Affordable' : (language === 'es' ? 'Mais Acessível' : 'Mais Acessível')}
            features={[
              { 
                text: language === 'en' ? '30 AI Generations / month' : (language === 'es' ? '30 Generaciones con IA / mes' : '30 Gerações de IA / mês'), 
                desc: language === 'en' ? 'Sufficient for creating and optimizing dozens of variants.' : (language === 'es' ? 'Suficiente para crear y optimizar decenas de variantes de copy.' : 'Suficiente para criar e otimizar dezenas de variações e copys.') 
              },
              { 
                text: language === 'en' ? 'Unlimited Landing Pages' : (language === 'es' ? 'Páginas Ilimitadas' : 'Landing Pages Ilimitadas'), 
                desc: language === 'en' ? 'Create as many pages as you want without limits.' : (language === 'es' ? 'Cree tantas páginas como desee sin límites.' : 'Crie quantas páginas desejar sem limites.') 
              },
              { 
                text: language === 'en' ? '20,000 Visitors / month' : (language === 'es' ? '20.000 Visitantes / mes' : '20.000 Visitantes/mês'), 
                desc: language === 'en' ? 'Perfect for low-to-medium paid traffic campaigns.' : (language === 'es' ? 'Ideal para campañas moderadas de tráfico pagado.' : 'Ideal para campanhas de tráfego pago moderadas.') 
              },
              { 
                text: language === 'en' ? 'Advanced Decision AI' : (language === 'es' ? 'IA de Decisión Avanzada' : 'IA de Decisão Avançada'), 
                desc: language === 'en' ? 'AI that analyzes real data to suggest high-conversion actions.' : (language === 'es' ? 'IA que analiza datos del embudo para sugerir mejoras.' : 'IA que analisa dados reais para sugerir mudanças de alta conversão.') 
              },
              { 
                text: language === 'en' ? 'Guided Setup by AI (5 min)' : (language === 'es' ? 'Configuración por IA (5 min)' : 'Setup Guiado por IA (5min)'), 
                desc: language === 'en' ? 'Automatic, super-fast onboarding to launch quickly.' : (language === 'es' ? 'Instalación intuitiva y guiada para lanzar rápido.' : 'Configuração automática e intuitiva para começar rápido.') 
              },
              { 
                text: language === 'en' ? '24/7 Human-like AI Agent' : (language === 'es' ? 'Agente IA Inteligente 24h' : 'Agente de IA Humanizado 24h'), 
                desc: language === 'en' ? 'Intelligent support to troubleshoot or bounce page layouts.' : (language === 'es' ? 'Soporte inteligente por chat disponible a toda hora.' : 'Suporte inteligente via IA disponível a qualquer hora.') 
              }
            ]}
            onAction={() => { setIsLogin(false); setShowAuth(true); }}
          />

          <LandingPricingCard 
            title="Scale"
            price={isPostLaunch ? "497" : "347"}
            anchorPrice="497"
            isPostLaunch={isPostLaunch}
            desc={language === 'en' ? 'For businesses looking for aggressive scaling and advanced tools.' : (language === 'es' ? 'Para negocios en expansión que requieren herramientas avanzadas.' : 'Para negócios que precisam de escala agressiva e ferramentas avançadas.')}
            highlighted
            features={[
              { 
                text: language === 'en' ? 'Everything in Pro Plan' : (language === 'es' ? 'Todo lo del plan Pro' : 'Tudo do plano Pro'), 
                desc: language === 'en' ? 'All Pro components and features fully included.' : (language === 'es' ? 'Todos los recursos del plan Pro incluidos.' : 'Todos os recursos do plano Pro incluídos.') 
              },
              { 
                text: language === 'en' ? '120 AI Generations / month' : (language === 'es' ? '120 Generaciones con IA / mes' : '120 Gerações de IA / mês'), 
                desc: language === 'en' ? 'Ideal for multiple scaling products and running intensive A/B tests.' : (language === 'es' ? 'Ideal para múltiples productos a escala y pruebas estables de copy.' : 'Ideal para escalar múltiplos produtos e rodar testes A/B estruturados.') 
              },
              { 
                text: language === 'en' ? '100,000 Visitors / month' : (language === 'es' ? '100.000 Visitantes / mes' : '100.000 Visitantes/mês'), 
                desc: language === 'en' ? 'Engineered for major campaigns and high volume.' : (language === 'es' ? 'Soporte para lanzamientos masivos y tráfico pesado.' : 'Suporte para grandes lançamentos e tráfego pesado.') 
              },
              { 
                text: language === 'en' ? 'Smart Copywriter AI' : (language === 'es' ? 'Redactor Creativo IA (Avanzado)' : 'Redator Publicitário IA (Avançado)'), 
                desc: language === 'en' ? 'Copy structured like elite copywriting models.' : (language === 'es' ? 'IA entrenada con modelos copywriting de alto impacto.' : 'IA treinada com os maiores copywriters do mundo para textos de alta conversão.') 
              },
              { 
                text: language === 'en' ? 'Intelligent Core Optimizer' : (language === 'es' ? 'Optimizador Inteligente' : 'Otimizador Inteligente (Avançado)'), 
                desc: language === 'en' ? 'In-depth behavioral heatmaps and suggestions.' : (language === 'es' ? 'Mapeo detallado de conductas de compra.' : 'Análise profunda de comportamento do usuário e sugestões automáticas.') 
              },
              { 
                text: language === 'en' ? 'Open Strategic Networking' : (language === 'es' ? 'Networking Comercial Activo' : 'Networking Liberado'), 
                desc: language === 'en' ? 'Join premium digital partners and fast-scale players.' : (language === 'es' ? 'Acceso a nuestro foro de aliados comerciales.' : 'Acesso à nossa rede exclusiva de parceiros e negócios estratégicos.') 
              },
              { 
                text: language === 'en' ? 'Infinite Domain Mapping' : (language === 'es' ? 'Dominios Personalizados' : 'Domínios Customizados'), 
                desc: language === 'en' ? 'Connect your own domain address across all portals.' : (language === 'es' ? 'Habilite dominios propios en todas sus páginas.' : 'Use seu próprio domínio (ex: oferta.seusite.com) em todas as páginas.') 
              },
              { 
                text: language === 'en' ? 'Predictive AI Score' : (language === 'es' ? 'IA Preventiva Quantum' : 'IA Preditiva Quantum'), 
                desc: language === 'en' ? 'Predict potential conversion scores before launching.' : (language === 'es' ? 'Módulo predictivo para anticipar el éxito de su página.' : 'IA que prevê a taxa de conversão antes mesmo de você publicar.') 
              }
            ]}
            onAction={() => { setIsLogin(false); setShowAuth(true); }}
          />

          <LandingPricingCard 
            title="Enterprise"
            price={isPostLaunch ? "997" : "647"}
            anchorPrice="997"
            isPostLaunch={isPostLaunch}
            desc={language === 'en' ? 'The peak of strategic Generative AI for high-volume operations.' : (language === 'es' ? 'La cumbre de la IA generativa para grandes corporativos.' : 'O ápice da IA Generativa Estratégica para grandes operações.')}
            features={[
              { 
                text: language === 'en' ? 'Everything in Scale Plan' : (language === 'es' ? 'Todo lo del plan Scale' : 'Tudo do plano Scale'), 
                desc: language === 'en' ? 'All Scale features included out of the box.' : (language === 'es' ? 'Todos los recursos del plan Scale incluidos.' : 'Todos os recursos do plano Scale incluídos.') 
              },
              { 
                text: language === 'en' ? 'Unlimited AI Generations*' : (language === 'es' ? 'Generaciones con IA Ilimitadas*' : 'Gerações de IA Ilimitadas*'), 
                desc: language === 'en' ? 'Unlimited free usage governed by our continuous fair-use protocol.' : (language === 'es' ? 'Uso libre ilimitado respaldado por nuestra política de uso justo.' : 'Gerações livres e ilimitadas protegidas por política de uso justo corporativa.') 
              },
              { 
                text: language === 'en' ? 'Unlimited Visitors' : (language === 'es' ? 'Visitante Corriente Ilimitado' : 'Visitantes Ilimitados'), 
                desc: language === 'en' ? 'Ultra-stable server setup for high-availability campaigns.' : (language === 'es' ? 'Infraestructura de alta disponibilidad sin cuotas.' : 'Infraestrutura de alta disponibilidade sem limites de tráfego.') 
              },
              { 
                text: language === 'en' ? 'Custom Customer Onboarding' : (language === 'es' ? 'Onboarding Estratégico de CRM' : 'Onboarding de Dados Estratégico'), 
                desc: language === 'en' ? 'Teach the model using your historical sales data.' : (language === 'es' ? 'IA entrenada con datos directos de ventas y CRM.' : 'IA treinada automaticamente com seus dados de CRM e vendas.') 
              },
              { 
                text: language === 'en' ? 'Full API Integration Suite' : (language === 'es' ? 'API de Conectividad Total' : 'API de Integração Total'), 
                desc: language === 'en' ? 'Integrate custom apps and CRM solutions smoothly.' : (language === 'es' ? 'Conecte OptiVelo con su ecosistema de datos.' : 'Conecte o OptiVelo ao seu CRM, ERP e ecossistema de dados.') 
              },
              { 
                text: language === 'en' ? 'Custom AI Partner' : (language === 'es' ? 'Estratega de Cuentas IA 24h' : 'Agente de IA Estratégico 24h'), 
                desc: language === 'en' ? 'A model fine-tuned for your exact business segment.' : (language === 'es' ? 'Soporte Quantum dedicado a mejorar su modelo de negocio.' : 'Suporte Quantum via IA dedicada ao seu modelo de negócio.') 
              },
              { 
                text: language === 'en' ? 'Contract-backed 99.9% SLA' : (language === 'es' ? 'Garantía del 99.9% en Contrato' : 'SLA de 99.9% em Contrato'), 
                desc: language === 'en' ? 'Enterprise stability agreement for mission-critical operations.' : (language === 'es' ? 'Garantía de estabilidad para operaciones que no pueden detenerse.' : 'Garantia de estabilidade para operações que não podem parar.') 
              }
            ]}
            onAction={() => { setIsLogin(false); setShowAuth(true); }}
          />
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-24 px-4 lg:px-8 max-w-7xl mx-auto space-y-16 border-t border-white/5 relative z-10">
        <div className="text-left space-y-4 max-w-3xl">
          <div className="flex items-center gap-2 text-indigo-400 font-mono text-xs uppercase tracking-[0.25em]">
            <div className="w-1.5 h-1.5 rounded-full bg-indigo-400" />
            <span>05 / FEEDBACK</span>
          </div>
          <h2 className="text-3xl lg:text-4xl font-sans font-black text-white tracking-tight uppercase">
            {language === 'en' ? 'Who uses OptiVelo, scales.' : (language === 'es' ? 'Quien usa OptiVelo, escala.' : 'Quem usa o OptiVelo, escala.')}
          </h2>
          <p className="text-sm text-slate-400 font-normal">
            {language === 'en' ? 'Stories of entrepreneurs who transformed their operations with the power of our AI.' : (language === 'es' ? 'Historias de emprendedores que transformaron sus resultados con la ayuda de nuestra IA.' : 'Histórias de empreendedores que transformaram suas operações com o poder da nossa IA.')}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <TestimonialCard 
            name="Ricardo Santos"
            role={language === 'en' ? 'CEO at TechFlow' : (language === 'es' ? 'CEO de TechFlow' : 'CEO da TechFlow')}
            content={language === 'en' ? 'OptiVelo reduced our CPL by 45% in the first week. The decision AI is frighteningly precise.' : (language === 'es' ? 'OptiVelo redujo nuestro CPL en un 45% la primera semana. La IA de decisión es asombrosa.' : 'O OptiVelo reduziu nosso CPL em 45% na primeira semana. A IA de decisão é assustadora de tão precisa.')}
            image="https://picsum.photos/seed/ricardo/100/100"
          />
          <TestimonialCard 
            name="Mariana Costa"
            role={language === 'en' ? 'Digital Creator' : (language === 'es' ? 'Infoproductora' : 'Infoprodutora')}
            content={language === 'en' ? 'Finally a tool that thinks for me. The Smart Copywriter generates text that sells far better than any agency I have ever hired.' : (language === 'es' ? 'Por fin una herramienta que piensa por mí. El Smart Copywriter genera mejores mensajes que cualquier agencia que haya tenido.' : 'Finalmente uma ferramenta que pensa por mim. O Smart Copywriter gera textos que vendem muito mais que qualquer agência que já contratei.')}
            image="https://picsum.photos/seed/mariana/100/100"
          />
          <TestimonialCard 
            name="André Luiz"
            role={language === 'en' ? 'Media Buyer' : (language === 'es' ? 'Gestor de Tráfico' : 'Gestor de Tráfego')}
            content={language === 'en' ? 'The ability to build full multi-page sites with the same conversion intelligence of landing pages changed the game for my e-commerce clients.' : (language === 'es' ? 'El poder crear sitios completos utilizando el motor optimizador de conversión cambió el juego para mis clientes de e-commerce.' : 'O diferencial de poder criar sites completos com a mesma inteligência das landing pages mudou o jogo para meus clientes de e-commerce.')}
            image="https://picsum.photos/seed/andre/100/100"
          />
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-24 px-4 lg:px-8 max-w-4xl mx-auto space-y-16 border-t border-white/5 relative z-10">
        <div className="text-left space-y-4">
          <div className="flex items-center gap-2 text-indigo-400 font-mono text-xs uppercase tracking-[0.25em]">
            <div className="w-1.5 h-1.5 rounded-full bg-indigo-400" />
            <span>06 / COMMON QUESTIONS</span>
          </div>
          <h2 className="text-3xl lg:text-4xl font-sans font-black text-white tracking-tight uppercase">
            {language === 'en' ? 'Frequently Asked Questions' : (language === 'es' ? 'Preguntas Frecuentes' : 'Dúvidas Frequentes')}
          </h2>
          <p className="text-sm text-slate-400 font-normal">
            {language === 'en' ? 'Everything you need to know to begin your Quantum journey.' : (language === 'es' ? 'Todo lo que necesita saber para comenzar su viaje Quantum.' : 'Tudo o que você precisa saber para começar sua jornada Quantum.')}
          </p>
        </div>

        <div className="space-y-4">
          <FAQItem 
            question={language === 'en' ? 'Does OptiVelo replace a traffic manager?' : (language === 'es' ? '¿OptiVelo reemplaza al gestor de tráfico?' : 'O OptiVelo substitui um gestor de tráfego?')}
            answer={language === 'en' ? 'No, it enhances their work. OptiVelo takes care of conversion (what happens after the click), ensuring your ad spend is not wasted on low-performing pages.' : (language === 'es' ? 'No, potencia su trabajo. OptiVelo se encarga de la conversión (después del clic), logrando que su inversión publicitaria no se pierda en páginas ineficaces.' : 'Não, ele potencializa o trabalho do gestor. O OptiVelo cuida da conversão (o que acontece depois do clique), garantindo que o dinheiro investido em anúncios não seja desperdiçado em páginas ruins.')}
          />
          <FAQItem 
            question={language === 'en' ? 'Do I need design or programming experience?' : (language === 'es' ? '¿Necesito saber programar o diseñar?' : 'Preciso saber programar ou desenhar?')}
            answer={language === 'en' ? 'Absolutely not. Our interface is 100% visual and our AI handles all technical aspects, from styling to optimizing the underlying code for blazing-fast speed.' : (language === 'es' ? 'Absolutamente no. Nuestra plataforma es 100% visual y la IA maneja el aspecto de desarrollo y código para máxima velocidad.' : 'Absolutamente não. Nossa interface é 100% visual e nossa IA cuida de toda a parte técnica, desde o design até a otimização do código para velocidade máxima.')}
          />
          <FAQItem 
            question={language === 'en' ? 'Can I use my own domain name?' : (language === 'es' ? '¿Puedo usar mi propio dominio?' : 'Posso usar meu próprio domínio?')}
            answer={language === 'en' ? 'Yes! Starting with the Scale plan, you can easily map your folders, domains, and subdomains to maintain your professional branding.' : (language === 'es' ? '¡Sí! Desde el plan Scale, puede conectar sus dominios y subdominios personalizados para preservar su marca corporativa.' : 'Sim! A partir do plano Scale, você pode conectar seus próprios domínios e subdomínios para manter sua marca profissional.')}
          />
          <FAQItem 
            question={language === 'en' ? 'How does the AI customer support work?' : (language === 'es' ? '¿Como funciona el soporte de la IA?' : 'Como funciona o suporte da IA?')}
            answer={language === 'en' ? 'Our VeloBot v2.0.1 is ready 24/7 inside the workspace to answer questions, propose CRO modifications, and assist in strategic configuration.' : (language === 'es' ? 'Nuestro VeloBot v2.0.1 está en línea 24/7 para responder dudas técnicas, sugerir mejoras para sus páginas y guiarle conceptualmente.' : 'Nosso VeloBot v2.0.1 está disponível 24/7 dentro da plataforma para tirar dúvidas técnicas, sugerir melhorias nas suas páginas e ajudar na configuração estratégica.')}
          />
        </div>
      </section>

      <footer className="py-24 border-t border-white/5 bg-[#020202] text-center space-y-12 relative z-10">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-8 text-left">
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded bg-white flex items-center justify-center">
                <Waves className="w-4 h-4 text-black fill-current" />
              </div>
              <span className="text-xl font-sans font-black tracking-tight text-white uppercase">OptiVelo</span>
            </div>
            <p className="text-xs text-slate-500 max-w-sm leading-relaxed">
              {language === 'en' 
                ? 'High-performance software engine with integrated active conversion CRO, built for ambitious brands.' 
                : (language === 'es'
                  ? 'Ecosistema de alta performance con optimización de conversión activa para marcas líderes.'
                  : 'Ecossistema de alta performance com otimização ativa de conversão para marcas que lideram.')}
            </p>
          </div>
          
          <div className="flex flex-wrap gap-8 text-xs font-mono uppercase tracking-widest text-slate-500">
            <button onClick={() => setShowTerms(true)} className="hover:text-white transition-colors">
              {language === 'en' ? 'Terms of Use' : (language === 'es' ? 'Términos de Uso' : 'Termos de Uso')}
            </button>
            <button onClick={() => setShowPrivacy(true)} className="hover:text-white transition-colors">
              {language === 'en' ? 'Privacy' : (language === 'es' ? 'Privacidad' : 'Privacidade')}
            </button>
            <button onClick={() => setShowContact(true)} className="hover:text-white transition-colors">
              {language === 'en' ? 'Contact' : (language === 'es' ? 'Contacto' : 'Contato')}
            </button>
          </div>
        </div>
        
        <div className="max-w-7xl mx-auto px-4 lg:px-8 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4 text-left">
          <p className="text-[11px] font-mono text-slate-600">
            {language === 'en' ? '© 2026 OptiVelo. All rights reserved.' : (language === 'es' ? '© 2026 OptiVelo. Todos los derechos reservados.' : '© 2026 OptiVelo - optivelo.com.br. Todos os direitos reservados.')}
          </p>
          <p className="text-[11px] font-mono text-slate-600">
            {language === 'en' ? 'Designed for speed.' : 'Desenvolvido para máxima velocidade.'}
          </p>
        </div>
      </footer>
      <PublicChat />
    </div>
  );
};

const GlossaryItem = ({ title, desc, icon: Icon }: any) => (
  <div className="premium-card p-8 space-y-4 group hover:border-indigo-500/30 transition-all">
    <div className="w-12 h-12 bg-indigo-500/10 rounded-2xl flex items-center justify-center text-indigo-400 group-hover:scale-110 transition-transform">
      <Icon className="w-6 h-6" />
    </div>
    <div className="space-y-2">
      <h4 className="text-lg font-bold text-white tracking-tight">{title}</h4>
      <p className="text-sm text-slate-500 leading-relaxed">{desc}</p>
    </div>
  </div>
);

const ShowcaseCard = ({ title, desc, prompt, icon: Icon }: any) => {
  const [image, setImage] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadImage = async () => {
      const url = await generateAppImage(prompt);
      setImage(url || `https://picsum.photos/seed/${title}/800/450`);
      setLoading(false);
    };
    loadImage();
  }, [prompt, title]);

  return (
    <div className="premium-card group overflow-hidden flex flex-col h-full border-white/5 hover:border-indigo-500/30 transition-all">
      <div className="relative aspect-video overflow-hidden bg-slate-900">
        {loading ? (
          <div className="w-full h-full flex items-center justify-center">
            <Loader2 className="w-6 h-6 text-indigo-500 animate-spin" />
          </div>
        ) : (
          <img 
            src={image!} 
            alt={title}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 opacity-60 group-hover:opacity-100"
            referrerPolicy="no-referrer"
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-60" />
        <div className="absolute top-4 left-4 p-2 bg-black/40 backdrop-blur-md rounded-xl border border-white/10">
          <Icon className="w-4 h-4 text-indigo-400" />
        </div>
      </div>
      
      <div className="p-8 space-y-3 flex-grow flex flex-col">
        <h3 className="text-xl font-bold text-white tracking-tight group-hover:text-indigo-400 transition-colors">
          {title}
        </h3>
        <p className="text-sm text-slate-500 leading-relaxed flex-grow">
          {desc}
        </p>
        <div className="pt-6 flex items-center justify-between border-t border-white/5">
          <span className="text-[12px] font-bold text-indigo-500 uppercase tracking-widest">Motor OptiVelo Ativo</span>
          <div className="flex items-center gap-1">
            <div className="w-1 h-1 rounded-full bg-emerald-500 animate-pulse" />
            <span className="text-[8px] font-bold text-emerald-500 uppercase tracking-widest">Otimizado</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const LandingPricingCard = ({ title, price, desc, features, highlighted, onAction, isPostLaunch, anchorPrice, badge }: any) => {
  const { language } = useLanguage();

  const getCardPriceAndCurrency = (basePrice: string, targetLanguage: string) => {
    if (basePrice === "0" || basePrice === "Free") {
      return { symbol: "", priceStr: "0", suffix: "" };
    }

    if (targetLanguage === 'pt') {
      return { symbol: "R$", priceStr: basePrice, suffix: "/ mês" };
    } else if (targetLanguage === 'en') {
      let usdPrice = "42.00";
      if (basePrice === "197") usdPrice = "42.00";
      else if (basePrice === "297") usdPrice = "62.00";
      else if (basePrice === "347") usdPrice = "74.00";
      else if (basePrice === "497") usdPrice = "104.00";
      else if (basePrice === "647") usdPrice = "138.00";
      else if (basePrice === "997") usdPrice = "208.00";
      return { symbol: "$", priceStr: usdPrice, suffix: "/ mo" };
    } else { // es
      let eurPrice = "39.00";
      if (basePrice === "197") eurPrice = "39.00";
      else if (basePrice === "297") eurPrice = "59.00";
      else if (basePrice === "347") eurPrice = "69.00";
      else if (basePrice === "497") eurPrice = "99.00";
      else if (basePrice === "647") eurPrice = "129.00";
      else if (basePrice === "997") eurPrice = "199.00";
      return { symbol: "€", priceStr: eurPrice, suffix: "/ mes" };
    }
  };

  const pObj = getCardPriceAndCurrency(price, language);
  const aObj = getCardPriceAndCurrency(anchorPrice, language);

  return (
    <div className={`relative flex flex-col p-8 rounded-xl border transition-all duration-500 group ${
      highlighted 
        ? 'bg-[#0e0e0e] border-indigo-500/30 shadow-[0_0_50px_rgba(99,102,241,0.03)] scale-105 z-10 text-white' 
        : 'bg-[#0a0a0a] border-white/5 hover:border-white/15 text-white'
    }`}>
      {highlighted && !isPostLaunch && !badge && (
        <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-indigo-500 text-white text-[9px] font-mono uppercase tracking-[0.2em] px-3 py-1 rounded-full flex items-center gap-1.5 shadow-xl">
          <Star className="w-2.5 h-2.5 fill-white" />
          {language === 'en' ? 'Founding Member' : (language === 'es' ? 'Miembro Fundador' : 'Membro Fundador')}
        </div>
      )}

      {badge && (
        <div className={`absolute -top-3.5 left-1/2 -translate-x-1/2 px-3 py-1 rounded-full text-[9px] font-mono uppercase tracking-[0.2em] flex items-center gap-1.5 shadow-xl ${
          highlighted ? 'bg-indigo-500 text-white' : 'bg-white/10 text-white border border-white/10'
        }`}>
          <Sparkles className="w-2.5 h-2.5" />
          {badge}
        </div>
      )}

      <div className="mb-8 space-y-4">
        <h3 className="text-xs font-mono uppercase tracking-[0.2em] text-slate-500">{title}</h3>
        <div className="flex items-baseline gap-1">
          {price === "0" ? (
            <span className="text-3xl font-sans font-black tracking-tight uppercase">
              {language === 'en' ? 'Free' : (language === 'es' ? 'Gratis' : 'Grátis')}
            </span>
          ) : (
            <>
              <span className="text-xs font-mono text-slate-500 align-super">{pObj.symbol}</span>
              <span className="text-4xl font-sans font-black tracking-tighter">{pObj.priceStr}</span>
              <span className="text-xs font-mono text-slate-500">{pObj.suffix}</span>
            </>
          )}
        </div>
        {!isPostLaunch && price !== "0" && (
          <div className="inline-block px-2 py-0.5 rounded bg-indigo-500/10 text-indigo-400 text-[8px] font-mono uppercase tracking-[0.1em]">
            {language === 'en' ? 'Post-Launch:' : (language === 'es' ? 'Post-Lanzamiento:' : 'Pós-Lançamento:')} {aObj.symbol} {aObj.priceStr}{aObj.suffix}
          </div>
        )}
        <p className="text-xs text-slate-400 font-normal leading-relaxed">{desc}</p>
      </div>

      <div className="flex-1 space-y-4 mb-8 border-t border-white/5 pt-6">
        {features.map((feature: any, i: number) => (
          <div key={i} className="flex items-center justify-between group/feat relative">
            <div className="flex items-start gap-3 text-left">
              <div className="mt-1 rounded-full p-0.5 bg-white/5">
                <Check className="w-3 h-3 text-indigo-400" />
              </div>
              <span className="text-xs text-slate-300 font-normal">{feature.text}</span>
            </div>
            
            <div className="relative flex items-center">
              <div className="cursor-help p-1 opacity-20 group-hover/feat:opacity-100 transition-opacity">
                <Shield className="w-3 h-3 text-slate-400" />
              </div>
              
              {/* Tooltip */}
              <div className="absolute bottom-full right-0 mb-2 w-48 p-3 bg-slate-950 text-slate-300 text-[10px] rounded-lg opacity-0 invisible group-hover/feat:opacity-100 group-hover/feat:visible transition-all z-50 shadow-2xl border border-white/10 pointer-events-none text-left">
                <p className="font-normal leading-relaxed">{feature.desc}</p>
                <div className="absolute top-full right-2 w-2 h-2 bg-slate-950 rotate-45 -translate-y-1"></div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <button 
        onClick={onAction}
        className={`w-full py-3.5 rounded-lg font-mono font-bold transition-all flex items-center justify-center gap-2 uppercase tracking-wider text-[11px] ${
          highlighted
            ? 'bg-white hover:bg-slate-200 text-black'
            : 'bg-white/5 hover:bg-white/10 text-white border border-white/10'
        }`}>
        {highlighted && <Waves className="w-3.5 h-3.5 fill-current" />}
        {language === 'en' ? 'Get Started' : (language === 'es' ? 'Comenzar Ahora' : 'Começar Agora')}
      </button>
    </div>
  );
};

const TestimonialCard = ({ name, role, content, image }: any) => (
  <div className="bg-[#0a0a0a] border border-white/5 rounded-xl p-8 space-y-6 hover:border-indigo-500/20 transition-all group text-left">
    <div className="flex items-center gap-4">
      <div className="w-10 h-10 rounded-full border border-white/15 overflow-hidden filter grayscale opacity-70 group-hover:opacity-100 transition-opacity">
        <img src={image} alt={name} className="w-full h-full object-cover" referrerPolicy="no-referrer" />
      </div>
      <div>
        <h4 className="text-sm font-bold text-white tracking-tight">{name}</h4>
        <p className="text-[10px] text-slate-500 font-mono uppercase tracking-[0.15em]">{role}</p>
      </div>
    </div>
    <p className="text-sm text-slate-400 leading-relaxed font-normal italic">"{content}"</p>
    <div className="flex gap-0.5">
      {[1,2,3,4,5].map(i => <Star key={i} className="w-3 h-3 text-indigo-400 fill-indigo-400" />)}
    </div>
  </div>
);

const FAQItem = ({ question, answer }: any) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="bg-[#0a0a0a] border border-white/5 overflow-hidden rounded-xl hover:border-white/10 transition-all text-left">
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="w-full p-6 flex items-center justify-between text-left"
      >
        <span className="text-sm font-bold text-white tracking-tight">{question}</span>
        <div className={`w-6 h-6 rounded-lg bg-white/5 flex items-center justify-center transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}>
          <ArrowRight className="w-3" />
        </div>
      </button>
      <div className={`transition-all duration-300 ease-in-out overflow-hidden ${isOpen ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'}`}>
        <div className="p-6 pt-0 text-sm text-slate-400 leading-relaxed font-normal border-t border-white/5">
          {answer}
        </div>
      </div>
    </div>
  );
};
